import * as $ from 'jquery';
import 'datepicker';
import 'selectize';
import * as Cookies from 'js-cookie';
import { wcagOptions } from "./wcag";
import { siteGeneral } from "./site";

export class bookingFormCommon {
	private wcag = new wcagOptions();
	private site = new siteGeneral();

	private ondCookieName = 'OnD_get';
	private ondSessDataId = 'ibeOnD';
	private ondCookieExpiry = new Date(new Date().getTime() + 60 * 60 * 1000); // 1 hours validity
	private $lowfareJson:any   = '';
	private $cashmilesType:any   = '';
	/**
	 * Focus input element
	 */
	inputFormFocus(): void {
		$('.form-validate')
		.off('focus', 'input')
		.on('focus','input',function() {
			let $input:any = $(this);
			// trigger focus state
			$input.addClass('input-focused');
			$('.booking-form--title',$input.parent()).addClass('input-filled');
			$('.date-form--title',$input.parent()).addClass('input-filled');

			// clear errors on focus
			$input.parent().removeClass('has-error');
			$('.booking-form--title',$input.parent()).removeClass('has-error');
			$('.date-form--title',$input.parent()).removeClass('has-error');
		})
		.off('blur', 'input')
		.on('blur','input',function() {
			let $input:any = $(this);
			let $datepickerInst:any = $.datepicker._getInst($input[0]);
			if ($input.val() == '') {
				// trigger empty state
				$input.removeClass('input-focused');
				$('.booking-form--title',$input.parent()).removeClass('input-filled');
			} else if ($datepickerInst && $datepickerInst.currentDay === 0) {
				$('.date-form--title',$input.parent()).removeClass('input-filled');
			}
			else {
				// trigger focused state
				$input.addClass('input-focused');
				$('.booking-form--title',$input.parent()).addClass('input-filled');
				$('.date-form--title',$input.parent()).addClass('input-filled');
			}
		})
		.off('click','.booking-form--title')
		.on('click','.booking-form--title',function() {
			let $label:any = $(this);
			$label.addClass('input-filled');
			$('input',$label.parent()).addClass('input-focused').focus();
		})
		.off('click','.date-form--title')
		.on('click','.date-form--title',function() {
			let $label:any = $(this);
			$label.addClass('input-filled');
			$('input',$label.parent()).addClass('input-focused');
		});

		// handle initial states on load
		$('.form-validate input').each(function(){
			let $input:any = $(this);
			if ($input.val() == '') {
				// trigger empty state
				$input.removeClass('input-focused');
				$('.booking-form--title',$input.parent()).removeClass('input-filled');
				$('.date-form--title',$input.parent()).removeClass('input-filled');
			}
			else {
				// trigger focused state
				$input.addClass('input-focused');
				$('.booking-form--title',$input.parent()).addClass('input-filled');
				$('.date-form--title',$input.parent()).addClass('input-filled');
			}
		});
	}

	/**
	 * [formFieldValidator description]
	 * Custom validators used for ibe  & other forms
	 * Todo: migrate to parsley at some point
	 */
	formFieldValidator(): void {
		let alphaNumericPattern = /^([a-zA-Z0-9_]+)$/;
		$('.name-validator').off('keydown').on('keydown', function (e: any) {
			// Allow: backspace, delete, tab, escape, enter
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
				// Allow: Ctrl/cmd+A
				(e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+C
				(e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+X
				(e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				// let it happen, don't do anything
					return;
			}
			// Ensure that it is a number and stop the keypress
			let arr: any = [8,16,17,20,32,35,36,37,38,39,40,45,46];
			for(let i = 65; i <= 90; i++){
				arr.push(i);
			}
			if ($.inArray(e.which, arr) === -1) {
				event.preventDefault();
			}
		});

		$('.alphanum-validator').off('keyup').on('keyup',function (e:any) {
			if (this.value.match(/[^a-zA-Z0-9 ]/g)) {
				this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
			}
		});

		$('.refnoticketnumber-validator').off('keyup').on('keyup',function (e:any) {

			if (this.value.length < 7) {
				if (alphaNumericPattern.test(this.value.replace('-', '')) && isNaN(this.value.replace('-', ''))) {
					this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
				}
			} else if (this.value.length > 6 && e.keyCode != 37 && e.keyCode != 39) {
				if (isNaN(this.value.replace('-', ''))) {
					this.value = this.value.substring(0, 6);
				} else if (!isNaN(this.value.replace('-', ''))) {
					this.value = this.value.replace(/[^0-9 ]/g, '');
					this.value = this.value.replace(/./g, function(v, i) {
						return i === 2 ? v + "-" : v;
					});
				}
			}
		});

		$('.num-validator').off('keydown').on('keydown', function(e: any) {
			-1 !== $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) || /65|67|86|88/.test(e.keyCode) && (!0 === e.ctrlKey || !0 === e.metaKey) || 35 <= e.keyCode && 40 >= e.keyCode || (e.shiftKey || 48 > e.keyCode || 57 < e.keyCode) && (96 > e.keyCode || 105 < e.keyCode) && e.preventDefault()
		});
	}

	/**
	 * Get Airport list from JSON and initialize to selectize
	 * @return {any} [description]
	 */
	airportlist(): any {
		// every static rendering will use promise. no need to worry about async issue
		let defer = $.Deferred();
		let _self = this;
		let airportListUrl:any;
		if($('.ibe-refresh').length >0) {
			airportListUrl = $('.desktop[data-get-airport-list]').attr('data-get-airport-list');
		}
		else {
			airportListUrl = $('[data-get-airport-list]').attr('data-get-airport-list');
		}
		
		if (($('#members-travel--subsidy').length)>0)
		{
			airportListUrl = $('[data-get-gts-airport-list]').attr('data-get-gts-airport-list');
		}
		// if (($('#ibe-standaloneq').length)>0)
		// {
		// 	airportListUrl = $('[data-get-cug-airport-list]').attr('data-get-cug-airport-list');
		// }
		let listItems:string;
		let storedOnDValidity = Cookies.get(_self.ondCookieName);
		let storedOnDList = sessionStorage.getItem(_self.ondSessDataId);
		/*
		if (_self.site.sessionStorage() && storedOnDList && storedOnDValidity) {
			storedOnDList = JSON.parse(storedOnDList);
			defer.resolve(storedOnDList);
		} else {
			*/
	//	}
		if (airportListUrl) {
			$.get(airportListUrl)
				.done((data:any) => {
					let dataParse:any = null;

					if (typeof data === 'string') {
						dataParse = JSON.parse(data);
					}	else {
						dataParse = data;
					}

					if (_self.site.sessionStorage()) {
						Cookies.set(_self.ondCookieName, 'true', { expires: _self.ondCookieExpiry });
						sessionStorage.setItem(_self.ondSessDataId, JSON.stringify(dataParse));
					}

					defer.resolve(dataParse);
				}).fail((error:any) => {
					defer.reject(error);
				});
		}
		return defer.promise();
	}

	airportlistNew(): any {
		// every static rendering will use promise. no need to worry about async issue
		let defer = $.Deferred();
		let _self = this;
		let $studentPortalDashboard: boolean = false;
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');		
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			$studentPortalDashboard = true;
		}
		let airportListUrl = $('[data-get-airport-list-new]').attr('data-get-airport-list-new');
		if (($('#members-travel--subsidy').length)>0)
		{
			airportListUrl = $('[data-get-gts-airport-list]').attr('data-get-gts-airport-list');
		}
		if ($studentPortalDashboard) {
			airportListUrl = $('[data-get-mhe-airport-list]').attr('data-get-mhe-airport-list');
		}

		let listItems:string;
		let storedOnDValidity = Cookies.get(_self.ondCookieName);
		let storedOnDList = sessionStorage.getItem(_self.ondSessDataId);
		/*
		if (_self.site.sessionStorage() && storedOnDList && storedOnDValidity) {
			storedOnDList = JSON.parse(storedOnDList);
			defer.resolve(storedOnDList);
		} else {
			*/
	//	}
		if (airportListUrl) {
			$.get(airportListUrl)
				.done((data:any) => {
					let dataParse:any = null;

					if (typeof data === 'string') {
						dataParse = JSON.parse(data);
					}	else {
						dataParse = data;
					}

					// if (_self.site.sessionStorage()) {
					// 	Cookies.set(_self.ondCookieName, 'true', { expires: _self.ondCookieExpiry });
					// 	sessionStorage.setItem(_self.ondSessDataId, JSON.stringify(dataParse));
					// }

					defer.resolve(dataParse);
				}).fail((error:any) => {
					defer.reject(error);
				});
		}
		return defer.promise();
	}

	airportlistMulticity(): any{
		// every static rendering will use promise. no need to worry about async issue
		let defer = $.Deferred();
		let _self = this;
		let airportListUrl;
		let lang = $('[data-get-airport-list-new]').attr('data-get-airport-list-new');
		if(lang){
			lang = lang.split('/').pop();
			let airportListBaseUrl = '/content/dam/mas/json/multicity/';
			airportListUrl = airportListBaseUrl + lang;
		}
		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			airportListUrl = '/dummy-data/airportlistMulticity.json';
		}
		
		let listItems:string;
		let storedOnDValidity = Cookies.get(_self.ondCookieName);
		let storedOnDList = sessionStorage.getItem(_self.ondSessDataId);

		if (lang) {
			$.get(airportListUrl)
				.done((data:any) => {
					let dataParse:any = null;

					if (typeof data === 'string') {
						dataParse = JSON.parse(data);
					}	else {
						dataParse = data;
					}
					defer.resolve(dataParse);
				}).fail((error:any) => {
					defer.reject(error);
				});
		}
		return defer.promise();
	}
	/**let
	 * Get MHoliday list from JSON and initialize to selectize
	 * @return {any} [description]
	 */
	revenueOND(): any {

		let defer = $.Deferred();
      //  if(window.location.hostname == "localhost" && window.location.port == "5000"){
     	let airportListUrl = $('[data-get-revenueond-list]').attr('data-get-revenueond-list');
            if(airportListUrl) {
                $.get(airportListUrl)
                    .done((data:any) => {
                        let dataParse:any = null;
    
                        if (typeof data === 'string') {
                            dataParse = JSON.parse(data);
                        }	else {
                            dataParse = data;
                        }
                        defer.resolve(dataParse);
                    }).fail((error:any) => {
                        defer.reject(error);
                    });
            }
        // }else{
        //     $.ajax({
        //         type: 'GET',
        //         url: '/bin/services/new/earnmilesondlist',
        //         success: function(data:any){
		// 			let dataParse:any = null;
		// 			if (typeof data === 'string') {
		// 				dataParse = JSON.parse(data);
		// 			}	else {
		// 				dataParse = data;
		// 			}
        //             defer.resolve(dataParse);			
        //         }, error: function(error: any) {
        //             defer.reject(error);
        //         }
        //     });
        // }
		return defer.promise();

	}
	/**
	 * Get MHoliday list from JSON and initialize to selectize
	 * @return {any} [description]
	 */
	mHolidayslist(): any {
		let defer = $.Deferred();
		let campaignID=$('[data-campaign-ond-campaignID]').data('campaignOndCampaignid');
		let data =  {
			mholidayONDCampaignId: campaignID
		};
		
        if(window.location.hostname == "localhost" && window.location.port == "5000"){
			let airportListUrl = '/dummy-data/getMholidaysOND.json';
			
			if(campaignID==='FHOOND' || campaignID===undefined){
				if(airportListUrl) {
					$.get(airportListUrl)
						.done((data:any) => {
							let dataParse:any = null;
		
							if (typeof data === 'string') {
								dataParse = JSON.parse(data);
							}	else {
								dataParse = data;
							}
							//dataParse.type = "mholiday";
							defer.resolve(dataParse);
						}).fail((error:any) => {
							defer.reject(error);
						});
				}
			}else{
				$.ajax({
					type: 'GET',
					url: airportListUrl,
					data: data,
					success: function(dataParse:any){
						defer.resolve(dataParse);			
					}, error: function(error: any) {
						defer.reject(error);
					}
				});
			}
        }else{
			if(campaignID==='FHOOND' || campaignID===undefined){
				$.ajax({
					type: 'GET',
					url: '/bin/services/new/mholidayond',
					success: function(dataParse:any){
					   // dataParse.type = "mholiday";
						defer.resolve(dataParse);			
					}, error: function(error: any) {
						defer.reject(error);
					}
				});
			}
			else{
				$.ajax({
					type: 'POST',
					url: '/bin/services/new/campaign/mholidayOND',
					data: data,
					success: function(dataParse:any){
						defer.resolve(dataParse);			
					}, error: function(error: any) {
						defer.reject(error);
					}
				});
			}
        }
		return defer.promise();
	}
	transfermHolidayslist(): any {
		let defer = $.Deferred();
        if(window.location.hostname == "localhost" && window.location.port == "5000"){
            let airportListUrl = '/dummy-data/getMholidaysOND.json';
            if(airportListUrl) {
                $.get(airportListUrl)
                    .done((data:any) => {
                        let dataParse:any = null;
    
                        if (typeof data === 'string') {
                            dataParse = JSON.parse(data);
                        }	else {
                            dataParse = data;
                        }
                        //dataParse.type = "mholiday";
                        defer.resolve(dataParse);
                    }).fail((error:any) => {
                        defer.reject(error);
                    });
            }
        }else{
            $.ajax({
                type: 'GET',
                url: '/bin/services/new/mholidayond',
                success: function(dataParse:any){
                   // dataParse.type = "mholiday";
                    defer.resolve(dataParse);			
                }, error: function(error: any) {
                    defer.reject(error);
                }
            });
        }
		return defer.promise();
	}
	/**
	 * [parseOnDListItems description]
	 * @param  {any}    response [description]
	 * @param  {string} type     [type of data (wci/redemption/revenue)]
	 * @return {string}          [description]
	 */
	parseOnDListItems(response:any, type:string):string {
		let listItems:string = "<option value=''> </option>";
		let _self = this;
        
		if (response[type].length) {
			for (let key in response[type][0]) {
				if (type === 'revenue') {

						// filter revenue data out of entire OnD list
						let dest:revenueObject = response[type][0][key];
						listItems += "<option value='" + dest.source.airportCode + "'>" +
														dest.source.airportName + ", " + dest.source.countryName +
														" (" + dest.source.airportCode + ")" +
													"</option>";
					

				}else if (type === 'redemption') {
					// filter redemption data out of entire OnD list
					let dest:revenueObject = response[type][0][key];
					listItems += "<option value='" + dest.source.airportCode + "'>" +
													dest.source.airportName + ", " + dest.source.countryName +
													" (" + dest.source.airportCode + ")" +
												"</option>";
				}
				else if (type === 'wci') {
					// filter wci data out of entire OnD list
					let dest:wciObject = response[type][0][key];
					listItems += "<option value='" + dest.airportCode + "'>" +
													dest.airportName + ", " + dest.countryName +
													" (" + dest.airportCode + ")" +
												"</option>";
				}
				else if (type === 'mholiday') {
						// filter mholiday data out of entire OnD list
						let dest:revenueObject = response[type][0][key];
						listItems += "<option value='" + dest.source.airportCode + "'>" +
														dest.source.airportName + ", " + dest.source.countryName +
														" (" + dest.source.airportCode + ")" +
													"</option>";
					
				}
				else if (type === 'sidetrip') {
					// filter sidetrip data out of entire OnD list
					let dest: revenueObject = response[type][0][key];
					listItems += "<option value='" + dest.source.airportCode + "'>" +
						dest.source.airportName + ", " + dest.source.countryName +
						" (" + dest.source.airportCode + ")" +
						"</option>";
				}
			}
			if (type === 'sidetrip') {
				if ($.isEmptyObject(response[type][0])) {
					$('#isSideTripEmpty').val('Yes')
					$('li.sideTrip').hide();
					$('li.ibe_sideTrip').hide();
				} else {
					$('#isSideTripEmpty').val('No')
					let isSideTripEnabled = $('#isSideTripEnable').val();
					if (isSideTripEnabled === 'Yes') {
						$('li.sideTrip').show();
						$('li.ibe_sideTrip').show();
					} else {
						$('li.sideTrip').hide();
						$('li.ibe_sideTrip').hide();
					}
				}

			}
		}

		return listItems;
	}

	parseOnDListItemsNew(response: any, type: string, destinationtype: string): string {
		let listItems: string = "<option value=''> </option>";
		let $cugParam: any = $('#search-param-cug').val();
		let $studentPortalDashboard: boolean = false;
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		let standAloneIBE: any = document.querySelector('#ibe-standalone-camp');
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			$studentPortalDashboard = true;
		}
		if (destinationtype === 'From' && $('#members-travel--subsidy').length < 1 && type !== 'sidetrip' && $cugParam != "CUG" && $studentPortalDashboard == false && standAloneIBE == null && $('#ibe-standalone-iframe').length < 1 && type!=='multicity') {
			listItems = this.populateFromLocRecentSearch(listItems, type, response);
		}
		let _self = this;
		if (type === 'revenue') {
			if (response[type] !== undefined) {
				for (let key in response[type]) {
					if (response[type][key] !== undefined) {
						if (key === 'online') {
							if ($('#members-travel--subsidy').length < 1) {
								listItems += "<optgroup label='With Malaysia Airlines'>";
							}
							for (let key1 in response[type][key]) {
								if (response[type][key][key1] !== undefined) {
									// filter revenue data out of entire OnD list
									let dest: revenueObject = response[type][key][key1];
									listItems += "<option value='" + dest.source.airportCode + "'>" +
										dest.source.airportName + "|" + dest.source.countryName +
										"|" + dest.source.airportCode +
										"</option>";
								}
							}
						}
						else if (key === 'others') {
							if ($('#members-travel--subsidy').length < 1) {
								listItems += "<optgroup label='With codeshare and partner network'>";
							}
							for (let key1 in response[type][key]) {
								if (response[type][key][key1] !== undefined) {
									// filter revenue data out of entire OnD list
									let dest: revenueObject = response[type][key][key1];
									listItems += "<option value='" + dest.source.airportCode + "'>" +
										dest.source.airportName + "|" + dest.source.countryName +
										"|" + dest.source.airportCode +
										"</option>";
								}
							}
						}
					}
				}
				if (destinationtype === 'From') {
					listItems += "</optgroup>";
				}
			}
		}
		else if (type === 'redemption') {
			if (response['revenue'] !== undefined) {
				for (let key in response['revenue']) {
					if (response['revenue'][key] !== undefined) {
						if (key === 'online') {
							if ($('#members-travel--subsidy').length < 1 && destinationtype !== 'flightstatus') {
								listItems += "<optgroup label='With Malaysia Airlines'>";
							}
							for (let key1 in response['revenue'][key]) {
								if (response['revenue'][key][key1] !== undefined) {
									// filter revenue data out of entire OnD list
									let dest: revenueObject = response['revenue'][key][key1];
									listItems += "<option value='" + dest.source.airportCode + "'>" +
										dest.source.airportName + "|" + dest.source.countryName +
										"|" + dest.source.airportCode +
										"</option>";
								}
							}
						}
						else if (key === 'others') {
							if ($studentPortalDashboard) {
								if ($('#members-travel--subsidy').length < 1) {
									listItems += "<optgroup label='With codeshare and partner network'>";
								}
								for (let key1 in response['revenue'][key]) {
									if (response['revenue'][key][key1] !== undefined) {
										// filter revenue data out of entire OnD list
										let dest: revenueObject = response['revenue'][key][key1];

										listItems += "<option value='" + dest.source.airportCode + "'>" +
											dest.source.airportName + "|" + dest.source.countryName +
											"|" + dest.source.airportCode +
											"</option>";

									}
								}
							}
						}


					}

				}
				if (destinationtype === 'From') {
					listItems += "</optgroup>";
				}
			}
		}
		else if (type === 'sidetrip') {
			if (response[type] !== undefined) {
				for (let key in response[type]) {
					if (response[type][key] !== undefined) {
						if (key === 'online') {
							if ($('#members-travel--subsidy').length < 1) {
								listItems += "<optgroup label='With Malaysia Airlines'>";
							}
							for (let key1 in response[type][key]) {
								if (response[type][key][key1] !== undefined) {
									// filter revenue data out of entire OnD list
									let dest: revenueObject = response[type][key][key1];
									listItems += "<option value='" + dest.source.airportCode + "'>" +
										dest.source.airportName + "|" + dest.source.countryName +
										"|" + dest.source.airportCode +
										"</option>";
								}
							}
						}
						else if (key === 'others') {
							if ($('#members-travel--subsidy').length < 1) {
								listItems += "<optgroup label='With codeshare and partner network'>";
							}
							for (let key1 in response[type][key]) {
								if (response[type][key][key1] !== undefined) {
									// filter revenue data out of entire OnD list
									let dest: revenueObject = response[type][key][key1];
									listItems += "<option value='" + dest.source.airportCode + "'>" +
										dest.source.airportName + "|" + dest.source.countryName +
										"|" + dest.source.airportCode +
										"</option>";
								}
							}
						}
					}
				}
				if (destinationtype === 'From') {
					listItems += "</optgroup>";
				}
			}
			if (type === 'sidetrip') {
				if ($.isEmptyObject(response[type]['online']) && $.isEmptyObject(response[type]['others'])) {
					$('#isSideTripEmpty').val('Yes')
					$('li.sideTrip').hide();
					$('li.ibe_sideTrip').hide();
				} else {
					$('#isSideTripEmpty').val('No')
					let isSideTripEnabled = $('#isSideTripEnable').val();
					if (isSideTripEnabled === 'Yes') {
						$('li.sideTrip').show();
						$('li.ibe_sideTrip').show();
					} else {
						$('li.sideTrip').hide();
						$('li.ibe_sideTrip').hide();
					}
				}

			}
		}
		else if (type === 'multicity'){
			if (response[type] !== undefined) {
				for (let key in response[type]) {
					if (response[type][key] !== undefined) {
						if (key === 'online') {

							listItems += "<optgroup label='With Malaysia Airlines'>";
						
							for (let key1 in response[type][key]) {
								if (response[type][key][key1] !== undefined) {

									// filter multicity data out of entire OnD list
									let dest: revenueObject = response[type][key][key1];
										listItems += "<option value='" + dest.source.airportCode + "'>" +
											dest.source.airportName + "|" + dest.source.countryName +
											"|" + dest.source.airportCode +
											"</option>";
						
								}
							}
						}
						else if (key === 'others') {
							listItems += "<optgroup label='With codeshare and partner network'>";
						
							for (let key1 in response[type][key]) {
								if (response[type][key][key1] !== undefined) {
									// filter revenue data out of entire OnD list
									let dest: revenueObject = response[type][key][key1];
										listItems += "<option value='" + dest.source.airportCode + "'>" +
											dest.source.airportName + "|" + dest.source.countryName +
											"|" + dest.source.airportCode +
							"</option>";
									
				}
							}
						}
					}
				}
				if (destinationtype === 'From') {
					listItems += "</optgroup>";
				}
			}	
		}
		return listItems;
	}

	populateFromLocRecentSearch(listItems: any, type: string, response: any): string {
		let fromCity: string,
			toCity: string,
			fromCityName: string,
			enFromCityName: string,
			toCityName: string,
			fromCountry: string,
			toCountry: string,
			fromDate: string,
			fromDateValue: string,
			toDate: string,
			toDateValue: string,
			totalPssgr: string,
			cabinClass: string,
			paymenttype:string,
			enrichAlwaysOn:string;
			
		//if (type === 'revenue') {
			let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);

			if (recentSearchCookieArr.length > 0) {
				listItems += "<optgroup label='Recent Searches'>";
				for (var i = 3; i > 0; i--) {
					let recentSearchCookieVal = recentSearchCookieArr[i];
					//  recentSearchCookieVal = recentSearchCookieVal.split("=")[1].replace(/"/g,"");
					let recentItem = "recent-search-cookie-" + i;
					recentSearchCookieVal = readValueFromCookie(recentItem).replace(/"/g, "");

					if (recentSearchCookieVal != '') {
						let recentSearchCookieValArr = recentSearchCookieVal.split("-");
						fromCity = recentSearchCookieValArr[0];
						toCity = recentSearchCookieValArr[1];
						fromDate = recentSearchCookieValArr[2];
						fromDateValue = recentSearchCookieValArr[3];
						totalPssgr = recentSearchCookieValArr[4];
						cabinClass = recentSearchCookieValArr[5];
						if(recentSearchCookieValArr[9]=='EAON')
						{
							enrichAlwaysOn = recentSearchCookieValArr[9];
						}

						if (response[type] !== undefined) {
							for (let key in response[type]) {
								if (response[type][key] !== undefined) {
									for (let key1 in response[type][key]) {
										if (response[type][key][key1] !== undefined) {
											if (response[type][key][key1].source.airportCode === fromCity) {
												fromCityName = response[type][key][key1].source.airportName;
												fromCountry = response[type][key][key1].source.countryName;
												enFromCityName = response[type][key][key1].source.enAirportName == undefined ? key1 : response[type][key][key1].source.enAirportName;
												let dest: Array<any> = response[type][key][enFromCityName]['destinations'];
												if (dest !== undefined) {
													for (let key in dest) {
														if (dest[key].length) {
															for (let key1 in dest[key][0]) {
																// filter revenue/redemption data out of entire OnD list
																let dest2: destObject = dest[key][0][key1];
																if (dest2.airportCode === toCity) {
																	toCityName = dest2.airportName;
																	toCountry = dest2.countryName;
																}

															}
														}

													}
												}
											}
										}
									}

								}
							}
						}
						if (recentSearchCookieValArr.length > 6) {
							toDate = recentSearchCookieValArr[6];
							toDateValue = recentSearchCookieValArr[7];
							paymenttype=recentSearchCookieValArr[8];
						}

						listItems += "<option value='" + fromCity + '_' + i + "R'>Recent|" +
							fromCity + "|" + fromCityName + "|" + toCity + "|" + toCityName + "|" +
							fromDate + "|" + fromDateValue + "|" + toDate + "|" + toDateValue + "|" +
							fromCountry + "|" + toCountry + "|" + cabinClass + "|" + totalPssgr +"|" + paymenttype + "|" + enrichAlwaysOn
							"</option>";
					}
				}
				listItems += "</optgroup>";
			}
		//}

		function getCookieByMatch(regex: RegExp) {
			let cs: any = document.cookie.split(/;\s*/),
				ret: Array<any> = [];
			for (var i: number = 0; i < cs.length; i++) {
				if (cs[i].match(regex)) {
					ret.push(cs[i]);
				}
			}
			return ret;
		}
		/* Read cookie value by name */
		function readValueFromCookie(name: string): any {
			var json = "";
			var ca = document.cookie.split(';');

			name = name + "=";

			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return decodeURIComponent(c.substring(name.length, c.length).replace(/\+/g, ' '));
				};
			}
			return json;
		}

		return listItems;
	}

	parseNewsletterListItems(response:any):string {
		let type:string = 'newsletter';
		let listItems:string = "<option value=''> </option>";

		if (response[type].length) {
			for (let key in response[type][0]) {
				let dest:newsletterObject = response[type][0][key];
				// filter newsletter data out of entire OnD list
				listItems += "<option value='" + dest.airportName  + " " +
												'(' + dest.airportCode + ')' + "'>" +
												dest.airportName + ", " + dest.countryName +
											"</option>";
			}
		}

		return listItems;
	}

	/**
	 * IBE Cabin class element
	 * This covers only desktop cabin class elements
	 */
	cabinClass(): void {
		let _self = this;
		let $cabinClass = $('.cabin-class');
		let $cabinSelected:any = $cabinClass.selectize({
			onInitialize: () => {
				_self.wcag.selectizeInputAria($cabinClass[0].selectize);
			},
			onFocus: () =>  {
				$cabinClass.find('.booking-form--title').addClass('input-filled');
				$cabinClass.find('.selectize-control.single .selectize-input').addClass('select-filled');		
			},
			onChange: () =>  {
				$cabinClass.find('.booking-form--title').addClass('input-filled');
				$cabinClass.find('.selectize-control.single .selectize-input').addClass('select-filled');		
			},
			onBlur: () => {
				let $cabinClassChange = $('.cabin-class option:selected').text();
				if ($cabinClassChange == '') {
					$cabinClass.find('.booking-form--title').removeClass('input-filled');
					$cabinClass.find('selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$cabinClass.find('.booking-form--title').addClass('input-filled');
					$cabinClass.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
				$('.cabin-class').attr('data-ibeclicked', 'true');
			},
			selectOnTab: true
		});

		$cabinSelected.each(function(){
			let cabinItem = this;
			let $cabinItem = $(this);
			$cabinItem.parent().find('.booking-form--title').addClass('input-filled');
			$cabinItem.parent().find('.selectize-control.single .selectize-input').addClass('select-filled');

			// if cabin class is not preselected on load (selected value is empty, default to economy class
			if (!$cabinItem.find('option:selected').val().length) {
				cabinItem.selectize.setValue('CFFECO');
			}
		});

		if (($('#ibe-standalone-travelpass').length) > 0) {
			let $cabinClassTravelPass: any = $('#ibe-standalone-travelpass').find('.cabin-class');			
			let options = $cabinClassTravelPass[0].selectize.options;
			let destVars: any = Object.keys(options);

			destVars.forEach(function (destVar: any) {
				if (destVar !== 'CFFECO') {
					$cabinClassTravelPass[0].selectize.removeOption(destVar);
				}
			});			
		}
	}

	/**
	 * add custom event to extend jquery datepicker
	 * !!!NOTE:
	 * - this function only has to be instantiated once. do not reinstantiate or else will trigger
	 * infinite loop
	 */
	datePickerAfterShowEvent():void {
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function(inst:any) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
	}

	/**
	 * Append datepicker title message to datepicker div on open
	 * @param  {string} msgText      [description]
	 * @param  {any}    datepickerEl [description]
	 */
	appendDatepickerTitle(msgText:string, datepickerEl:any):void {
		if (datepickerEl) {
			let $dateP:any = $(datepickerEl);

			if (msgText != undefined && msgText.length) {
				$dateP.addClass('ui-datepicker-has-title-text');
				$dateP.prepend('<div class="ui-datepicker-title-text"><span>'+ msgText +'</span></div>');
			} else {
				console.error('missing datepicker dataset title value');
				$dateP.prepend('<div class="ui-datepicker-title-text"><span>Please select date</span></div>');
			}
			// return true;
		} else {
			// return false;
		}
	}

	/**
	 * [preloader description]
	 */
	preloader(): void {
		$('#status').fadeIn(250);
		$('#preloader').fadeIn(250);
	}

	/**
	 * [preloaderClose description]
	 */
	preloaderClose(): void {
		setTimeout(() => {
			$('#status').fadeOut(250);
			$('#preloader').fadeOut(250);
		}, 1000);
	}

	/**
	 * Update airport dropdowns for different flows based on user selection
	 * @return {any} [description]
	 */
	updateAirportOnDListOnFlowChange(flowType:any, originCode:any, updateType:any):void {
		// console.log('updateAirportOnDListOnFlowChange', flowType, originCode, updateType);
		// let servletUrl:string;
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if(studentEnrichIdCookieVal !=null && studentDashboard !=null && flowType !== 'Sidetrip'){
			flowType ="Redemption";
		}

		let _self = this;

		_self.airportlist().then((listData: any) => {

			let type:string = flowType.toLowerCase();
			let airportList = listData;
			let flow:string = flowType.toLowerCase();
			let selectOptions:Array<any> = [];

			if (originCode === '') { // when changing payment type (cash/miles)
				// console.log('no origin code');
				if (airportList[type].length) {
					for (let key in airportList[type][0]) {
						// filter revenue/redemption/sidetrip data out of entire OnD list
						let dest:revenueObject = airportList[type][0][key];
						selectOptions.push({
							text: dest.source.airportName + ", " + dest.source.countryName + " (" + dest.source.airportCode + ")",
							value: dest.source.airportCode
						});
					}
				}
			} else { // when changing src destination
				// console.log('with origin code', originCode);
				if (airportList[type].length) {
					let dest:Array<any> = airportList[type][0][originCode]['destinations'];
					if (dest.length) {
						for (let key in dest[0]) {
							// filter revenue/redemption/sidetrip data out of entire OnD list
							let dest2:destObject = dest[0][key];
							selectOptions.push({
								text: dest2.airportName + ", " + dest2.countryName + " (" + dest2.airportCode + ")",
								value: dest2.airportCode
							});
						}
					}
				}
			}

			if (flowType === 'Sidetrip' && originCode !== '') {
				if (airportList[type].length) {
					let sideTrip: sidetripObject = airportList[type][0][originCode];
					let ibeNowDate:any      = new Date();
					let ibeTodayDate:any    = new Date(ibeNowDate.getFullYear(), ibeNowDate.getMonth(), ibeNowDate.getDate(), 0, 0, 0, 0);
					let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
					let maxLimitDate: any = new Date(ibeNowDate.getFullYear(), ibeNowDate.getMonth(), ibeNowDate.getDate() + maxDays, 0, 0, 0, 0);
					let startDate: any = new Date(sideTrip.source.travelPeriodFrom) < ibeTodayDate? ibeTodayDate: new Date(sideTrip.source.travelPeriodFrom);
					let enDate: any = new Date(sideTrip.source.travelPeriodTo) > maxLimitDate? maxLimitDate:  new Date(sideTrip.source.travelPeriodTo);
					let $tripType = $('.trip-sidetrip-container .trip-type--container li.selected a').attr('data-triptype');
					if ($tripType == 'R') {
						$('.returnsideTrip .departureDateSideTrip').val('');
						$('.returnsideTrip .returnDateSideTrip').val('');
						if (startDate > maxLimitDate) {
							$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'disabled', true);
							$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'disabled', true);
							$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'disabled', true);
						} else {
							$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'disabled', false);
							$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'disabled', false);
							$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'disabled', false);
						}
						$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'minDate', startDate);
						$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'maxDate', enDate);
						$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'minDate', startDate);
						$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'maxDate', enDate);
						$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'minDate', startDate);
						$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'maxDate', enDate);
					} else {
						$('.oneWaysideTrip .departureDateSideTrip').val('');
						if (startDate > maxLimitDate) {
							$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'disabled', true);
							$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'disabled', true);
							$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'disabled', true);
						} else {
							$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'disabled', false);
							$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'disabled', false);
							$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'disabled', false);
						}
						$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'minDate', startDate);
						$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'maxDate', enDate);
						$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'minDate', startDate);
						$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'maxDate', enDate);
					}
					let cabinClassItem: Array<any> = [];
					let cabinClass: Array<any> = [];
					cabinClassItem = sideTrip.source.cabinClass.split(',');
					if (cabinClassItem.length) {
						for (let key in cabinClassItem) {
							cabinClass.push({
								text: cabinClassItem[key].split(':')[1],
								value: cabinClassItem[key].split(':')[0]
							});
						}
					}
					if (cabinClass.length) {
						let selectizecabinClass = $('select.cabin-class-sidetrip')[0].selectize;
						selectizecabinClass.clear();
						selectizecabinClass.clearOptions();
						selectizecabinClass.renderCache = {};
						selectizecabinClass.load(function (callback: any) {
							callback(cabinClass);
						});
						selectizecabinClass.setValue(cabinClass[0].value);
					}
				}
			}

			let updateLocationType:any;
			// console.log('update type', typeof updateType);
			// console.log(updateType);
			if (typeof updateType === 'string') {
				// for original implementation (where used in bookingform ibe only)
				updateLocationType = $('.ibe-form--container').find(updateType);
			} else {
				// for all other OnD lists (new)
				updateLocationType = updateType;
			}
			let selectize = updateLocationType[0].selectize;

			selectize.clearOptions();
			selectize.renderCache = {};
			selectize.load(function(callback:any) {
				callback(selectOptions);
			});
		});
	}

	updateAirportOnDListOnFlowChangeMulticity(flowType: any, originCode: any, updateType: any, fromLocationEl:any): void {
		let _self = this;
		
		$.when(window['ibeOnDListNew']).done((listData: any) => {

			let type: string= 'multicity';
			let airportList = listData;
			
			let selectOptions: Array<any> = [];
			
			if (airportList[type] !== undefined) {
				for (let key in airportList[type]) {
					if (airportList[type][key] !== undefined) {
						for (let key1 in airportList[type][key]) {
							if (airportList[type][key][key1] !== undefined) {
								if (airportList[type][key][key1].source.airportCode === originCode) {
			
									let originname: string = airportList[type][key][key1].source.airportName;
									let enOriginName: string = airportList[type][key][key1].source.enAirportName == undefined ? key1 : airportList[type][key][key1].source.enAirportName;
									let dest: Array<any> = airportList[type][key][enOriginName]['destinations'];
									if (dest !== undefined) {
										for (let key in dest) {
											if (key === 'online') {
												if (dest[key].length) {
													for (let key1 in dest[key][0]) {
														// filter multicity data out of entire OnD list
														let dest2: destObject = dest[key][0][key1];
															selectOptions.push({
																text: dest2.airportName + "|" + dest2.countryName + "|" + dest2.airportCode,
																value: dest2.airportCode,
																type: 'online'
															});
														

													}
												}

											}
											else if (key === 'others') {
												if (dest[key].length) {
													for (let key1 in dest[key][0]) {
														// filter multicity data out of entire OnD list
														let dest2: destObject = dest[key][0][key1];

															selectOptions.push({
																text: dest2.airportName + "|" + dest2.countryName + "|" + dest2.airportCode,
																value: dest2.airportCode,
																type: 'others'
															});
													}
												}

											}
	
										}
									}
								}
							}
						}

					}
				}
			}
			
			

			let updateLocationType: any;
			updateLocationType = updateType;
			let selectize = updateLocationType[0].selectize;

			selectize.clearOptions();
			selectize.renderCache = {};
			selectize.load(function (callback: any) {
				for (var i: number = 0; i < selectOptions.length; i++) {
					
					if (selectOptions[i].type === 'online') {
							selectize.addOptionGroup("online", {
								label: "With Malaysia Airlines"
							});
						
						selectize.addOption({
							text: selectOptions[i].text,
							value: selectOptions[i].value,
							optgroup: "online"
						});
					} else if (selectOptions[i].type === 'others') {
							selectize.addOptionGroup("others", {
								label: "With codeshare and partner network"
							});
						
						selectize.addOption({
							text: selectOptions[i].text,
							value: selectOptions[i].value,
							optgroup: "others"
						});
					}
					
				}
				callback();
			});
		});
	}
	updateAirportOnDListOnFlowChangeNew(flowType: any, originCode: any, updateType: any): void {
		// console.log('updateAirportOnDListOnFlowChange', flowType, originCode, updateType);
		// let servletUrl:string;
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		let isFlightstatus = false;
		let isFlightSchedule = false;
		let isMOT = false;
		let switchIdentifier: any;
		let $studentPortalDashboard: boolean = false;		
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			if($('.mot_switch .toggle input[type="checkbox"]').is(':visible')) {
				if ($('.mot_switch .toggle input[type="checkbox"]').prop("checked") == true) {
					isMOT = true;
				}
			}
			if($('.mob_mot_switch .toggle input[type="checkbox"]').is(':visible')) {
				if ($('.mob_mot_switch .toggle input[type="checkbox"]').prop("checked") == true) {
					isMOT = true;
				}
			}
			flowType = "Redemption";
			$studentPortalDashboard = true;
		}

		if(flowType === 'flightstatus') {
			flowType = 'Redemption';
			isFlightstatus = true; 
		}

		if(flowType === 'flightschedule') {			
			isFlightSchedule = true; 
		}	

		let _self = this;
		$.when(window['ibeOnDListNew']).done((listData: any) => {

			let type: string;
			let sideTrip: sidetripObject;
			if(flowType === 'Sidetrip') {
				type = flowType.toLowerCase();
			} else {
				type = 'revenue';
			}
			if(isMOT) {
				type = 'flysiswa';
			}			
			let airportList = listData;
			let flow: string = flowType.toLowerCase();
			let selectOptions: Array<any> = [];
			let filtertype: string = flowType.toLowerCase();
			var listItems:string ;

			let fromCity: string,
			toCity: string,
			fromCityName: string,
			enFromCityName: string,
			toCityName: string,
			fromCountry: string,
			toCountry: string,
			fromDate: string,
			fromDateValue: string,
			toDate: string,
			toDateValue: string,
			totalPssgr: string,
			cabinClass: string,
			paymenttype:string,
			enrichAlwaysOn:string;

			var response = listData;
		//if (type === 'revenue') {
			let recentSearchCookieArr = this.getCookieByMatch(/^recent-search-cookie-\d+=/);

			if (recentSearchCookieArr.length > 0 && !isFlightstatus && !isFlightSchedule && $studentPortalDashboard == false) {
				listItems += "<optgroup label='Recent Searches'>";
				for (var i = 3; i > 0; i--) {
					let recentSearchCookieVal = recentSearchCookieArr[i];
					//  recentSearchCookieVal = recentSearchCookieVal.split("=")[1].replace(/"/g,"");
					let recentItem = "recent-search-cookie-" + i;
					recentSearchCookieVal = this.readValueFromCookie(recentItem).replace(/"/g, "");

					if (recentSearchCookieVal != '') {
						let recentSearchCookieValArr = recentSearchCookieVal.split("-");
						fromCity = recentSearchCookieValArr[0];
						toCity = recentSearchCookieValArr[1];
						fromDate = recentSearchCookieValArr[2];
						fromDateValue = recentSearchCookieValArr[3];
						totalPssgr = recentSearchCookieValArr[4];
						cabinClass = recentSearchCookieValArr[5];
						if(recentSearchCookieValArr[9]=='EAON')
						{
							enrichAlwaysOn = recentSearchCookieValArr[9];
						}
						if (response[type] !== undefined) {
							for (let key in response[type]) {
								if (response[type][key] !== undefined) {
									for (let key1 in response[type][key]) {
										if (response[type][key][key1] !== undefined) {
											if (response[type][key][key1].source.airportCode === fromCity) {
												fromCityName = response[type][key][key1].source.airportName;
												fromCountry = response[type][key][key1].source.countryName;
												enFromCityName = response[type][key][key1].source.enAirportName == undefined ? key1 : response[type][key][key1].source.enAirportName;
												let dest: Array<any> = response[type][key][enFromCityName]['destinations'];
												if (dest !== undefined) {
													for (let key in dest) {
														if (dest[key].length) {
															for (let key1 in dest[key][0]) {
																// filter revenue/redemption data out of entire OnD list
																let dest2: destObject = dest[key][0][key1];
																if (dest2.airportCode === toCity) {
																	toCityName = dest2.airportName;
																	toCountry = dest2.countryName;
																}

															}
														}

													}
												}
											}
										}
									}

								}
							}
						}
						if (recentSearchCookieValArr.length > 6) {
							toDate = recentSearchCookieValArr[6];
							toDateValue = recentSearchCookieValArr[7];
							paymenttype=recentSearchCookieValArr[8];
						}
						// listItems += "<option value='" + fromCity + '_' + i + "R'>Recent|" +
						// 	fromCity + "|" + fromCityName + "|" + toCity + "|" + toCityName + "|" +
						// 	fromDate + "|" + fromDateValue + "|" + toDate + "|" + toDateValue + "|" +
						// 	fromCountry + "|" + toCountry + "|" + cabinClass + "|" + totalPssgr +
						// 	"</option>";
						if (originCode === '' && updateType.selector != 'select.ibe-to--location'){ 
							selectOptions.push({
								text: "Recent|" +
								fromCity + "|" + fromCityName + "|" + toCity + "|" + toCityName + "|" +
								fromDate + "|" + fromDateValue + "|" + toDate + "|" + toDateValue + "|" +
								fromCountry + "|" + toCountry + "|" + cabinClass + "|" + totalPssgr + "|" + paymenttype + "|" + enrichAlwaysOn,
								value: fromCity + '_' + i + 'R',
								type: 'recent-search'
							});
						}
					}
				}
				
			}
			if (originCode === '') { // when changing payment type (cash/miles)
				// console.log('no origin code');
				if (airportList[type] !== undefined) {
					for (let key in airportList[type]) {
						if (airportList[type][key] !== undefined) {
							if (key === 'online') {
								for (let key1 in airportList[type][key]) {
									if (airportList[type][key][key1] !== undefined) {
										// filter revenue/redemption data out of entire OnD list
										let dest: revenueObject = airportList[type][key][key1];
										if (isMOT) {
											if (dest.source.mot) {
												if (dest.source.mot.toLowerCase() == "true") {
													selectOptions.push({
														text: dest.source.airportName + "|" + dest.source.countryName + "|" + dest.source.airportCode,
														value: dest.source.airportCode,
														type: 'online'
													});
												}
											}
										}
										else {
											selectOptions.push({
												text: dest.source.airportName + "|" + dest.source.countryName + "|" + dest.source.airportCode,
												value: dest.source.airportCode,
												type: 'online'
											});
										}
									}

								}
							}
							else if (key === 'others' && filtertype !== 'redemption') {
								for (let key1 in airportList[type][key]) {
									if (airportList[type][key][key1] !== undefined) {
										// filter revenue/redemption data out of entire OnD list
										let dest: revenueObject = airportList[type][key][key1];
										selectOptions.push({
											text: dest.source.airportName + "|" + dest.source.countryName + "|" + dest.source.airportCode,
											value: dest.source.airportCode,
											type: 'other'
										});

									}
								}
							}
							else if (key === 'others' && $studentPortalDashboard) {
								for (let key1 in airportList[type][key]) {
									if (airportList[type][key][key1] !== undefined) {
										// filter revenue/redemption data out of entire OnD list
										let dest: revenueObject = airportList[type][key][key1];

										if (isMOT) {
											if (dest.source.mot) {
												if (dest.source.mot.toLowerCase() == "true") {
													selectOptions.push({
														text: dest.source.airportName + "|" + dest.source.countryName + "|" + dest.source.airportCode,
														value: dest.source.airportCode,
														type: 'online'
													});
												}
											}
										}
										else {
											selectOptions.push({
												text: dest.source.airportName + "|" + dest.source.countryName + "|" + dest.source.airportCode,
												value: dest.source.airportCode,
												type: 'other'
											});
										}


									}
								}
							}
						}
					}
				}
			} else { // when changing src destination
				// console.log('with origin code', originCode);
				if (airportList[type] !== undefined) {
					for (let key in airportList[type]) {
						if (airportList[type][key] !== undefined) {
							for (let key1 in airportList[type][key]) {
								if (airportList[type][key][key1] !== undefined) {
									if (airportList[type][key][key1].source.airportCode === originCode) {
										if(flowType === 'Sidetrip') {
											sideTrip = airportList[type][key][key1];
										}
										let originname: string = airportList[type][key][key1].source.airportName;
										let enOriginName: string = airportList[type][key][key1].source.enAirportName == undefined ? key1 : airportList[type][key][key1].source.enAirportName;
										let dest: Array<any> = airportList[type][key][enOriginName]['destinations'];
										if (dest !== undefined) {
											for (let key in dest) {
												if (key === 'online') {
													if (dest[key].length) {
														for (let key1 in dest[key][0]) {
															// filter revenue/redemption data out of entire OnD list
															let dest2: destObject = dest[key][0][key1];
															if (isMOT) {
																if (dest2.mot) {
																	if (dest2.mot.toLowerCase() == "true") {
																		selectOptions.push({
																			text: dest2.airportName + "|" + dest2.countryName + "|" + dest2.airportCode,
																			value: dest2.airportCode,
																			type: 'online'
																		});
																	}
																}
															}
															else {
															selectOptions.push({
																text: dest2.airportName + "|" + dest2.countryName + "|" + dest2.airportCode,
																value: dest2.airportCode,
																type: 'online'
															});
														}

														}
													}

												}
												else if (key === 'others' && filtertype !== 'redemption') {
													if (dest[key].length) {
														for (let key1 in dest[key][0]) {
															// filter revenue/redemption data out of entire OnD list
															let dest2: destObject = dest[key][0][key1];
															selectOptions.push({
																text: dest2.airportName + "|" + dest2.countryName + "|" + dest2.airportCode,
																value: dest2.airportCode,
																type: 'other'
															});

														}
													}

												}
												else if (key === 'others' && $studentPortalDashboard) {
													if (dest[key].length) {
														for (let key1 in dest[key][0]) {
															// filter revenue/redemption data out of entire OnD list
															let dest2: destObject = dest[key][0][key1];
															if (isMOT) {
																if (dest2.mot) {
																	if (dest2.mot.toLowerCase() == "true") {																		
																			selectOptions.push({
																				text: dest2.airportName + "|" + dest2.countryName + "|" + dest2.airportCode,
																				value: dest2.airportCode,
																				type: 'online'
																			});																		
																	}
																}
															}
															else {
																selectOptions.push({
																	text: dest2.airportName + "|" + dest2.countryName + "|" + dest2.airportCode,
																	value: dest2.airportCode,
																	type: 'other'
																});

															}

														}
													}
												}
											}
										}
									}
								}
							}

						}
					}
				}
			}

			if (flowType === 'Sidetrip' && originCode !== '' && ! $.isEmptyObject(sideTrip)) {
				if (airportList[type]!== undefined) {					
					let ibeNowDate:any      = new Date();
					let ibeTodayDate:any    = new Date(ibeNowDate.getFullYear(), ibeNowDate.getMonth(), ibeNowDate.getDate(), 0, 0, 0, 0);
					let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
					let maxLimitDate: any = new Date(ibeNowDate.getFullYear(), ibeNowDate.getMonth(), ibeNowDate.getDate() + maxDays, 0, 0, 0, 0);
					let startDate: any = new Date(sideTrip.source.travelPeriodFrom) < ibeTodayDate? ibeTodayDate: new Date(sideTrip.source.travelPeriodFrom);
					let enDate: any = new Date(sideTrip.source.travelPeriodTo) > maxLimitDate? maxLimitDate:  new Date(sideTrip.source.travelPeriodTo);
					let $tripType = $('.trip-sidetrip-container .trip-type--container li.selected a').attr('data-triptype');
					if ($tripType == 'R') {
						$('.returnsideTrip .departureDateSideTrip').val('');
						$('.returnsideTrip .returnDateSideTrip').val('');
						if (startDate > maxLimitDate) {
							$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'disabled', true);
							$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'disabled', true);
							$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'disabled', true);
						} else {
							$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'disabled', false);
							$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'disabled', false);
							$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'disabled', false);
						}
						$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'minDate', startDate);
						$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'maxDate', enDate);
						$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'minDate', startDate);
						$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'maxDate', enDate);
						$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'minDate', startDate);
						$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'maxDate', enDate);
					} else {
						$('.oneWaysideTrip .departureDateSideTrip').val('');
						if (startDate > maxLimitDate) {
							$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'disabled', true);
							$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'disabled', true);
							$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'disabled', true);
						} else {
							$('.returnsideTrip .departureDateSideTrip').datepicker('option', 'disabled', false);
							$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'disabled', false);
							$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'disabled', false);
						}
						$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'minDate', startDate);
						$('.oneWaysideTrip .departureDateSideTrip').datepicker('option', 'maxDate', enDate);
						$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'minDate', startDate);
						$('.returnsideTrip .returnDateSideTrip').datepicker('option', 'maxDate', enDate);
					}
					let cabinClassItem: Array<any> = [];
					let cabinClass: Array<any> = [];
					cabinClassItem = sideTrip.source.cabinClass.split(',');
					if (cabinClassItem.length) {
						for (let key in cabinClassItem) {
							cabinClass.push({
								text: cabinClassItem[key].split(':')[1],
								value: cabinClassItem[key].split(':')[0]
							});
						}
					}
					if (cabinClass.length) {
						let selectizecabinClass = $('select.cabin-class-sidetrip')[0].selectize;
						selectizecabinClass.clear();
						selectizecabinClass.clearOptions();
						selectizecabinClass.renderCache = {};
						selectizecabinClass.load(function (callback: any) {
							callback(cabinClass);
						});
						selectizecabinClass.setValue(cabinClass[0].value);
					}
				}
			}

			let updateLocationType: any;
			// console.log('update type', typeof updateType);
			// console.log(updateType);
			if (typeof updateType === 'string') {
				// for original implementation (where used in bookingform ibe only)
				updateLocationType = $('.ibe-form--container').find(updateType);
			} else {
				// for all other OnD lists (new)
				updateLocationType = updateType;
			}
			let selectize = updateLocationType[0].selectize;

			selectize.clearOptions();
			selectize.renderCache = {};

			//selectize.load(this.populateFromLocRecentSearch(listItems, flowType, listData));
			selectize.load(function (callback: any) {
				for (var i: number = 0; i < selectOptions.length; i++) {
					if (originCode === '' && updateType.selector != 'select.ibe-to--location'){
						if (selectOptions[i].type === 'recent-search') {
								if ($('#members-travel--subsidy').length < 1 && !isFlightstatus && $('#ibe-standalone-iframe').length < 1) {
									selectize.addOptionGroup("recent-search", {
										label: "Recent Searches"
									});
							}
							selectize.addOption({
								text: selectOptions[i].text,
								value: selectOptions[i].value,
								optgroup: "recent-search"
							});
						
						}
					}
					if (selectOptions[i].type === 'online') {
						if ($('#members-travel--subsidy').length < 1 && !isFlightstatus) {
							selectize.addOptionGroup("online", {
								label: "With Malaysia Airlines"
							});
							if(isMOT) {
								selectize.removeOptionGroup("online", {
									label: "With Malaysia Airlines"
								});
							}
						}
						selectize.addOption({
							text: selectOptions[i].text,
							value: selectOptions[i].value,
							optgroup: "online"
						});
					} else if (selectOptions[i].type === 'other') {
						if ($('#members-travel--subsidy').length < 1 && !isFlightstatus) {
							selectize.addOptionGroup("other", {
								label: "With codeshare and partner network"
							});
						}
						selectize.addOption({
							text: selectOptions[i].text,
							value: selectOptions[i].value,
							optgroup: "other"
						});
					}
				}
				callback();
			});
		});
	}
/**
	 * Update nHolidays dropdowns for different flows based on user selection
	 * @return {any} [description]
	 */
	updateMholidaysOnDListOnFlowChange(flowType:any, originCode:any, updateType:any):void {

		let _self = this;

		_self.mHolidayslist().then((listData: any) => {

			let type:string = flowType;
			let airportList = listData;
			let selectOptions:Array<any> = [];

			if (originCode === '') { 
				if (airportList[type].length) {
					for (let key in airportList[type][0]) {
						let dest:mholidayObject = airportList[type][0][key];
						
						selectOptions.push({
							text: dest.source.airportName + ", " + dest.source.countryName + " (" + dest.source.airportCode + ")",
							value: dest.source.cityCode+"-"+dest.source.airportCode
						});
					}
				}
			} else { // when changing src destination
				// console.log('with origin code', originCode);
				if (airportList[type].length) {
					let dest:Array<any> = airportList[type][0][originCode]['destinations'];
					if (dest.length) {
						for (let key in dest[0]) {
							let dest2:mholidayDestObject = dest[0][key];
							selectOptions.push({
								text: dest2.airportName + ", " + dest2.countryName + " (" + dest2.airportCode + ")",
								value: dest2.cityCode+"-"+dest2.airportCode
							});
						}
					}
				}
			}

			let updateLocationType:any;
			// console.log('update type', typeof updateType);
			// console.log(updateType);
			if (typeof updateType === 'string') {
				// for original implementation (where used in bookingform ibe only)
				updateLocationType = $('.ibe-form--container').find(updateType);
			} else {
				// for all other OnD lists (new)
				updateLocationType = updateType;
			}
			let selectize = updateLocationType[0].selectize;

			selectize.clearOptions();
			selectize.renderCache = {};
			selectize.load(function(callback:any) {
				callback(selectOptions);
			});
		});
	}
	updateRevenueOnDListOnFlowChange(flowType:any, originCode:any, updateType:any):void {

		let _self = this;

		_self.revenueOND().then((listData: any) => {

			let type:string = flowType;
			let airportList = listData;
			let selectOptions:Array<any> = [];

			if (originCode === '') { 
				if (airportList[type].length) {
					for (let key in airportList[type][0]) {
						let dest:mholidayObject = airportList[type][0][key];
						selectOptions.push({
							text: dest.source.airportName + ", " + dest.source.countryName + " (" + dest.source.airportCode + ")",
							value: dest.source.airportCode
						});
					}
				}
			} else { // when changing src destination
				// console.log('with origin code', originCode);
				if (airportList[type].length) {
					let dest:Array<any> = airportList[type][0][originCode]['destinations'];
					if (dest.length) {
						for (let key in dest[0]) {
							let dest2:mholidayDestObject = dest[0][key];
							selectOptions.push({
								text: dest2.airportName + ", " + dest2.countryName + " (" + dest2.airportCode + ")",
								value:dest2.airportCode
							});
						}
					}
				}
			}

			let updateLocationType:any;
			// console.log('update type', typeof updateType);
			// console.log(updateType);
			if (typeof updateType === 'string') {
				// for original implementation (where used in bookingform ibe only)
				updateLocationType = $('.miles-calculator--widget').find(updateType);
			} else {
				// for all other OnD lists (new)
				updateLocationType = updateType;
			}
			let selectize = updateLocationType[0].selectize;

			selectize.clearOptions();
			selectize.renderCache = {};
			selectize.load(function(callback:any) {
				callback(selectOptions);
			});
		});
	}

	getTravelPassAirPorts($data: any) {
		let _self = this;
		//let bcommon = _self.bcommon;
		var dataParse: any = null;
		//bcommon.preloader();		
		let travelPassAirPortListUrl: string = $('[data-get-travel-pass-airport-list]').attr('data-get-travel-pass-airport-list');
		if (travelPassAirPortListUrl) {
			$.ajax({
				type: 'GET',
				url: travelPassAirPortListUrl,
				data: $.param($data),
				async: false,
				success: function (data: any) {
					//bcommon.preloaderClose();				
					if (typeof data === 'string') {
						dataParse = JSON.parse(data);
					}
					else {
						dataParse = data;
					}
				},
				error: function (error: any) {
					//bcommon.preloaderClose();
					dataParse = null;
					$('#ibe-standalone-travelpass').hide();
					$.magnificPopup.open({
						items: {
							src: '#flypass--error-popup'
						},
						type: 'inline',
						midClick: true,
						enableEscapeKey: false,
						showCloseBtn: false,
						closeOnBgClick: false,
						modal: true,
						callbacks: {
							open: function () {
								var $content = $(this.content);
								$content.on('click', '.flypass-msg-btn-refresh', function () {
									$.magnificPopup.close();
									location.reload();
								});
							}
						}
					}, 0);
				}
			});
		}
		return dataParse;

	}

	updateTravelPassAirportList(originCode: any, updateType: any, airportList: any) {		
		if (airportList !== null) {			
			let type = 'travelpass';
			let selectOptions: Array<any> = [];
			if (originCode === '') { // when changing payment type (cash/miles)
				// console.log('no origin code');
				if (airportList[type] !== undefined) {
					for (let key in airportList[type]) {
						if (airportList[type][key] !== undefined) {
							if (key === 'online') {
								for (let key1 in airportList[type][key]) {
									if (airportList[type][key][key1] !== undefined) {
										// filter revenue/redemption data out of entire OnD list
										let dest: revenueObject = airportList[type][key][key1];
										selectOptions.push({
											text: dest.source.airportName + "|" + dest.source.countryName + "|" + dest.source.airportCode,
											value: dest.source.airportCode,
											type: 'online'
										});
									}

								}
							}
						}
					}
				}
			}
			else { // when changing src destination
				// console.log('with origin code', originCode);
				if (airportList[type] !== undefined) {
					for (let key in airportList[type]) {
						if (airportList[type][key] !== undefined) {
							for (let key1 in airportList[type][key]) {
								if (airportList[type][key][key1] !== undefined) {
									if (airportList[type][key][key1].source.airportCode === originCode) {
										let originname: string = airportList[type][key][key1].source.airportName;
										let dest: Array<any> = airportList[type][key][key1]['destinations'];
										if (dest !== undefined) {
											for (let key in dest) {
												if (key === 'online') {
													if (dest[key].length) {
														for (let key1 in dest[key][0]) {
															// filter revenue/redemption data out of entire OnD list
															let dest2: tpDestObject = dest[key][0][key1];
															selectOptions.push({
																text: dest2.airportName + "|" + dest2.countryName + "|" + dest2.airportCode,
																value: dest2.airportCode + "|" + dest2.officeId,
																type: 'online'
															});

														}
													}

												}
											}
										}
									}
								}
							}

						}
					}
				}
			}

			for (let i = 0; i < updateType.length; ++i) {
				let updateLocationType: any;
				// console.log('update type', typeof updateType);
				// console.log(updateType);
				if (typeof updateType[i] === 'string') {
					// for original implementation (where used in bookingform ibe only)
					updateLocationType = $('.ibe-form--container').find(updateType[i]);
				} else {
					// for all other OnD lists (new)
					updateLocationType = updateType[i];
				}
				let selectize = updateLocationType[0].selectize;

				selectize.clearOptions();
				selectize.clear();
				selectize.renderCache = {};

				//selectize.load(this.populateFromLocRecentSearch(listItems, flowType, listData));
				selectize.load(function (callback: any) {
					for (var i: number = 0; i < selectOptions.length; i++) {
						if (selectOptions[i].type === 'online') {
							selectize.addOptionGroup("online", {
								label: "With Malaysia Airlines"
							});
							selectize.addOption({
								text: selectOptions[i].text,
								value: selectOptions[i].value,
								optgroup: "online"
							});
						}
					}
					callback();
				});
			} 
		}
	}

	updateMOTAirportList(scope:any, fromLocationIdentifier:any, toLocationIdentifier:any): void {
		let _self = this;
		let toLocationSelectize:any = scope.find('select'+toLocationIdentifier)[0].selectize;
		let fromLocationSelectize:any = scope.find('select'+fromLocationIdentifier)[0].selectize;
		fromLocationSelectize.clear(true);
		toLocationSelectize.clear(true);		
		_self.updateAirportOnDListOnFlowChangeNew("Redemption", '', scope.find('select' + fromLocationIdentifier));
		_self.updateAirportOnDListOnFlowChangeNew("Redemption", '', scope.find('select' + toLocationIdentifier));
		// clear to location as well (clear silently)
		toLocationSelectize.clear(true);
		toLocationSelectize.trigger('blur');
		fromLocationSelectize.clear(true);					
		fromLocationSelectize.trigger('blur');
		// let $cabinClass: any = $('.ibe-form--container').find('.cabin-class');
		// $cabinClass[0].selectize.setValue("CFFECO");	
		// let $cabinClassmob: any = $('.ibe-form--container').find('.cabin-class-mob');
		// $cabinClassmob[0].selectize.setValue("CFFECO");	
	}

	scrollToTopIBE(): void {
		let $mabHeader:any = $('#mab-header');
		let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');
		let $mabHeaderHeight:number = parseInt($mabHeader.outerHeight());
		let $ibePos    = $mobIbeNav.offset().top;
		let $scrollAmt = $ibePos - $mabHeaderHeight;

		window.scrollTo(0, $scrollAmt);
	}


/* Lowfare API*/
	lawfareAPI($fromVal: any = "", $toVal: any = "", $depDate: any = "") {
		let _self = this;
		let $screenSize: any = $(window).width();
		let $isEnableLowfareCalender: any = $('#isEnableLowfareCalender');
		let $isEnableLowfareMilesCalender: any = $('#isEnableLowfareMilesCalender');
		let $cashmile: any;
		let $scope: any = $('[data-ibe--book-flight]');
		let $scopeMob: any = $('#mobile-bookflight--container');
		let $cugParam: any = $('#search-param-cug').val();
		let $studentPortalDashboard: boolean = false;
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			$studentPortalDashboard = true;
		}
		if ($screenSize < 768) {
			$cashmile = $scopeMob.find('input[name="cash_miles_type"]:checked').val();
		}
		else {
			$cashmile = $scope.find('input[name="cash_miles_type"]:checked').val();
		}
		if ($cugParam != "CUG" && $studentPortalDashboard == false) {
			if (!($(".travel_passhistory")[0])) {
				if (($isEnableLowfareCalender.val() == 'true' && $cashmile == 'cash') || ($isEnableLowfareMilesCalender.val() == 'true' && $cashmile == 'miles')) {
					if ($fromVal != "" && $toVal != "") {
						$fromVal = $fromVal.trim().split('_')[0];
						let getlowfareurl: string = '';
						if (window.location.hostname === 'localhost' && window.location.port == "5000") {
							if ($cashmile != 'miles' && $isEnableLowfareCalender.val() == 'true') {
								getlowfareurl = '/dummy-data/lowFare.json';
							}
							else {
								getlowfareurl = '/dummy-data/lowFarePoints.json';
							}
						}
						else {

							let today: any;
							let dd: any;
							let yyyy: any;
							today = new Date();
							dd = today.getDate();
							let mm = today.getMonth() + 1;
							yyyy = today.getFullYear();
							if (dd < 10) {
								dd = '0' + dd;
							}

							if (mm < 10) {
								mm = '0' + mm;
							}
							today = dd + mm + yyyy.toString().substr(-2);
							if ($cashmile != 'miles') {
								getlowfareurl = '/bin/services/new/getLowfareDetails?origin=' + $fromVal + '&destination=' + $toVal + '&firstdate=' + today + '&farefamily=CFFECO&tripinterval=100';
							}
							else {
								getlowfareurl = '/bin/services/new/getLowfareMilesDetails?origin=' + $fromVal + '&destination=' + $toVal + '&firstdate=' + today + '&farefamily=CFFYMILES&tripinterval=100';
							}
							let $returnTrip: any = false;
							let $screenSize: any = $(window).width();
							if ($screenSize < 768) {
								if ($('#mobile-bookflight--container .returnTrip').hasClass('selected') == true) {
									$returnTrip = true;
								}
							} else {
								if ($('#book-flight--container .returnTrip').hasClass('selected') == true) {
									$returnTrip = true;
								}
							}
							if ($returnTrip == true) {
								if ($cashmile != 'miles') {
									getlowfareurl = '/bin/services/new/getReturnLowfareDetails?origin=' + $fromVal + '&destination=' + $toVal;
								}
								else {
									getlowfareurl = '/bin/services/new/getReturnLowfareMilesDetails?origin=' + $fromVal + '&destination=' + $toVal;
								}
								if ($depDate != "" && $depDate != "Invalid date") {
									if ($cashmile != 'miles') {
										getlowfareurl = '/bin/services/new/getReturnLowfareDetails?origin=' + $fromVal + '&destination=' + $toVal + '&departdate=' + $depDate + '&fromDepartDate=true';
									}
									else {
										getlowfareurl = '/bin/services/new/getReturnLowfareMilesDetails?origin=' + $fromVal + '&destination=' + $toVal + '&departdate=' + $depDate + '&fromDepartDate=true';
									}
								}

							}

						}
						$.ajax({
							type: 'GET',
							url: getlowfareurl,
							success: function (data: any) {
								let json: any = null;
								if (data != '') {
									if (typeof data === 'string') {
										json = JSON.parse(data);
									} else {
										json = data;
									}
								}
								_self.$lowfareJson = json;
								_self.$cashmilesType = $cashmile;
								_self.clearCSSRule();
								_self.updateDatePickerCells();

							},
							error: function (error: any) {
								console.log("Error while getting low fare info", error);
								_self.clearCSSRule();
							}
						});
					} else {
						if (_self.$cashmilesType != $cashmile) {
							_self.$lowfareJson = '';
						}
						_self.clearCSSRule();
						_self.updateDatePickerCells();

					}
				}
			}
		}

	}
	updateDatePickerCells() {

		let _self = this;
		var json = this.$lowfareJson;
		let $cashmile: any;
		let $scope:any                  = $('[data-ibe--book-flight]');
		let $scopeMob:any               = $('#mobile-bookflight--container');
		let $screenSize: any = $(window).width();
		if ($screenSize < 768) {
			$cashmile = $scopeMob.find('input[name="cash_miles_type"]:checked').val();
		}
		else {
			$cashmile = $scope.find('input[name="cash_miles_type"]:checked').val();
		}
		/* Wait until current callstack is finished so the datepicker
		   is fully rendered before attempting to modify contents */
		if (json != '' && json != null) {
			setTimeout(function () {
				//Fill this with the data you want to insert (I use and AJAX request).  Key is day of month
				//NOTE* watch out for CSS special characters in the value						
				var cellContents = { 1: '$20.00', 2: '4', 15: '60', 28: '99', 31: '3' };				
				//Select disabled days (span) for proper indexing but // apply the rule only to enabled days(a)
				let currency: any = '';
				let fareAmountNum: any;
				let fareAmountPoints: any ='';
				let fareAmount: any;
				$('.ui-datepicker td > *').each(function (idx: any, elem: any) {
					var dateOfDeparture;
					// dynamically create a css rule to add the contents //with the :after                         
					//             selector so we don't break the datepicker //functionality 
					let dd: any = elem.innerText;
					let yyyy: any = elem.parentNode.dataset.year;
					let mm: any = elem.parentNode.dataset.month;
					mm++;
					if (dd < 10) {
						dd = '0' + dd;
					}

					if (mm < 10) {
						mm = '0' + mm;
					}
					if (elem.parentNode.dataset.year != undefined) {
						var dateOfDeparture = dd + mm + yyyy.toString().substr(-2);;
						var searchTerm = dateOfDeparture;
						var results = json.filter(function (json: any) {
							return json.dateOfDeparture.indexOf(searchTerm) > -1;
						});
						//console.log(results); 
						if (results.length > 0) {
							if ($cashmile != 'miles') {
								fareAmountNum = parseInt(results[0].totalFareAmount);
								fareAmount = _self.currencyFormatter(fareAmountNum);
								currency = results[0].currency == undefined ? '' : results[0].currency;
							}
							else {
								fareAmountPoints = results[0].baseFareAmountMiles;
								fareAmount = _self.currencyFormatter(parseInt(fareAmountPoints));
							}
							var className = 'datepicker-content-' + dateOfDeparture.toString();

							if (fareAmount == 0) {
								_self.addCSSRule('.ui-datepicker td a.' + className + ':after {content: "\\a0";}', className); //&nbsp;
							}
							else {
								_self.addCSSRule('.ui-datepicker td a.' + className + ':after {content: "' + fareAmount + '";}', className);
								_self.addCSSRule('.ui-datepicker td span.' + className + ':after {content: "' + fareAmount + '";}', className);
								$(this).addClass(className);
								$(this).addClass('calender-lowfare-padding');
							}
						}
					}
				});
				var isIpad: boolean = false;
				if (navigator.userAgent.match(/iPad/i)) {
					isIpad = true;
				}
				if ($('.ui-datepicker-row-break').length == 0 && isIpad) {
					$('.ui-datepicker-title-text').append('<div class="ui-datepicker-row-break"></div>');
				}
				if ($cashmile != 'miles') {
					if (currency != '') {
						$('.ui-datepicker-row-break').html('&#x1F6C8; Fare displayed is for 1 adult only in <b><u>' + currency + '</b></u> and includes charges/taxes.');
					}
				}
				else {
					if (fareAmountPoints != '') {
						$('.ui-datepicker-row-break').html('&#x1F6C8; Fare displayed is for 1 adult only in <b><u>Enrich Points</b></u> and excludes charges/taxes.');
					}
				}
				if ($screenSize < 768 || isIpad) {
					let existAlignStyle: any = $('.ui-datepicker .ui-datepicker-group').attr('style');
					if (existAlignStyle != undefined) {
						existAlignStyle += ';width:calc(100% - 7px);margin-left: 7px !important';
					}
					else {
						existAlignStyle = 'width:calc(100% - 7px);margin-left: 7px !important';
					}
					$('.ui-datepicker .ui-datepicker-group').attr('style', existAlignStyle);
					$('.ui-datepicker .ui-datepicker-group-first').addClass('lowfare-calender-margin');
				}
				if (isIpad) {
					$('.ui-datepicker .ui-datepicker-title').addClass('lowfare-calender-ipad-margin');
				}
				if ($screenSize >= 768 && !isIpad) {
					let colWidth: any = $('.ui-datepicker-group-first').width() + $('.ui-datepicker-group-last').width() + 100;
					let existStyle: any = $('.ui-datepicker').attr('style');
					existStyle += ';width: ' + colWidth + 'px !important';
					$('.ui-datepicker').attr('style', existStyle);
				}
			}, 0);
		}
	}
	updateDatePickerCellsHoliday() {

		let _self = this;
		var json = this.$lowfareJson;
		let today:any = new Date();
		let $screenSize: any = $(window).width();

		/* Wait until current callstack is finished so the datepicker
		   is fully rendered before attempting to modify contents */
		if (json != '' && json != null && json.length!==0) {
			setTimeout(function () {
			
				//Select disabled days (span) for proper indexing but // apply the rule only to enabled days(a)
				let currency: any = '';
				let fareAmountNum: any;
				let fareAmount: any;

				$('.ui-datepicker td > *').each(function (idx: any, elem: any) {
					var dateOfDeparture;
					// dynamically create a css rule to add the contents //with the :after                         
					//             selector so we don't break the datepicker //functionality 
					let dd: any = elem.innerText;
					let yyyy: any = elem.parentNode.dataset.year;
					let mm: any = elem.parentNode.dataset.month;
					let currDate:any = new Date(yyyy,mm,dd);
					let difference:any =(currDate-today)/(1000*3600*24);
					mm++;
					if (dd < 10) {
						dd = '0' + dd;
					}

					if (mm < 10) {
						mm = '0' + mm;
					}
					if (elem.parentNode.dataset.year != undefined && difference<181) {
						var dateOfDeparture = dd + mm + yyyy.toString().substr(-2);;
						var searchTerm = dateOfDeparture;
						var results = json.filter(function (json: any) {
							return json.dateOfDeparture.indexOf(searchTerm) > -1;
						});
						if (results.length > 0) {
								fareAmountNum = parseInt(results[0].totalFareAmount);
								fareAmount = _self.currencyFormatter(fareAmountNum);
								// currency = results[0].currency == undefined ? '' : results[0].currency;
							
							var className = 'datepicker-content-' + dateOfDeparture.toString();

							if (fareAmount == 0) {
								_self.addCSSRule('.ui-datepicker td a.' + className + ':after {content: "\\a0";}', className); //&nbsp;
								$(this).parent().addClass(" ui-datepicker-unselectable ui-state-disabled");
							}
							else {
								// _self.addCSSRule('.ui-datepicker td a.' + className + ':after {content: "' + fareAmount + '";}', className);
								// _self.addCSSRule('.ui-datepicker td span.' + className + ':after {content: "' + fareAmount + '";}', className);
								$(this).addClass(className);
								$(this).addClass('calender-lowfare-padding');
							}
						}
						else{
							$(this).parent().addClass(" ui-datepicker-unselectable ui-state-disabled");
						}
					}
				});
				var isIpad: boolean = false;
				if (navigator.userAgent.match(/iPad/i)) {
					isIpad = true;
				}
				if ($('.ui-datepicker-row-break').length == 0 && isIpad) {
					$('.ui-datepicker-title-text').append('<div class="ui-datepicker-row-break"></div>');
				}

				if ($screenSize < 768 || isIpad) {
					let existAlignStyle: any = $('.ui-datepicker .ui-datepicker-group').attr('style');
					if (existAlignStyle != undefined) {
						existAlignStyle += ';width:calc(100% - 7px);margin-left: 7px !important';
					}
					else {
						existAlignStyle = 'width:calc(100% - 7px);margin-left: 7px !important';
					}
					$('.ui-datepicker .ui-datepicker-group').attr('style', existAlignStyle);
					$('.ui-datepicker .ui-datepicker-group-first').addClass('lowfare-calender-margin');
				}
				if (isIpad) {
					$('.ui-datepicker .ui-datepicker-title').addClass('lowfare-calender-ipad-margin');
				}
				if ($screenSize >= 768 && !isIpad) {
					let colWidth: any = $('.ui-datepicker-group-first').width() + $('.ui-datepicker-group-last').width() + 100;
					let existStyle: any = $('.ui-datepicker').attr('style');
					existStyle += ';width: ' + colWidth + 'px !important';
					$('.ui-datepicker').attr('style', existStyle);
				}
			}, 0);
		}
	}
	dynamicCSSRules: any = [];
	addCSSRule(rule: any, styleId: any) {
		if ($.inArray(rule, this.dynamicCSSRules) == -1) {
			$('head').append('<style id=' + styleId + '>' + rule + '</style>');
			this.dynamicCSSRules.push({ id: styleId, rule: rule });
		};
	}
	clearCSSRule() {
		if (this.dynamicCSSRules.length > 0) {
			$.each(this.dynamicCSSRules, function (id: any, value: any) {
				$('#' + value.id).remove();
			});
			this.dynamicCSSRules = [];
		}
	}
	lowfareApiMholiday($fromVal: any = "", $toVal: any = "", $depDate: any = ""){
		let _self = this;
		let $isMHHEnableLowfareCalender: any = $('#isMHHEnableLowfareCalender');

				if ($isMHHEnableLowfareCalender.val() == 'true') {
					if ($fromVal != "" && $toVal != "") {
						$fromVal = $fromVal.trim().split('_')[0];
						let getlowfareurl: string = '';
						if (window.location.hostname === 'localhost' && window.location.port == "5000") {
								getlowfareurl = '/dummy-data/lowFare.json';
													
						}
						else {
							// No dates required for return low fare	
							getlowfareurl = '/bin/services/new/getReturnLowfareDetails?origin=' + $fromVal + '&destination=' + $toVal;
						
						}
						$.ajax({
							type: 'GET',
							url: getlowfareurl,
							success: function (data: any) {
								let json: any = null;
								if (data != '') {
									if (typeof data === 'string') {
										json = JSON.parse(data);
									} else {
										json = data;
									}
								}
								_self.$lowfareJson = json;
								_self.clearCSSRule();
								_self.updateDatePickerCellsHoliday();

							},
							error: function (error: any) {
								console.log("Error while getting low fare info", error);
								_self.clearCSSRule();
							}
						});
					} else {
						_self.clearCSSRule();
						_self.updateDatePickerCellsHoliday();

					}
				}
			
		
	}
	currencyFormatter(amount: any) {
		let _self = this;
		if (Math.abs(amount) >= 10000000 && Math.abs(amount) < 1000000000) {
			return _self.digitsFormatter(Math.floor(Math.abs(amount) / 1000000)) + 'M';
		}
		else {
			return Math.abs(amount) >= 100000 ? _self.digitsFormatter(Math.floor(Math.abs(amount) / 1000)) + 'K' : _self.digitsFormatter(amount);
		}
	}
	digitsFormatter(amount: any) {
		return Math.abs(amount) >= 1000 ? amount.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") : amount;
	}

		/* Populate hotel OND list
	 	call to Tui API
	*/
	populatetourHotelList($scope:any): void {
		let _self = this;
		let $hotelInputVal:any;
		$scope.find('.tour-display-tui-container').on('mouseleave', function () {
			 $(this).hide();
			 $scope.find('.hotelInputClass').removeClass('hotel-input-boarder');
		});
		$(document).mouseup(function (event: any) {
			if ($(event.target).closest('.tour-display-tui-container').length
				=== 0) {
				$scope.find('.tour-display-tui-container').hide();
				$scope.find('.hotelInputClass').removeClass('hotel-input-boarder');
				if($scope.find('#hotelInputVal').val() === '') {
					$scope.find('.hotelInputClass').val('');
					$scope.find('.hotelInputClass').removeClass('input-focused');
					$('.booking-form--title',$scope.find('.hotelInputClass').parent()).removeClass('input-filled');
				}				
			}
		}); 
		$scope.find('.hotelInputClass').on('keydown', function (e:any) {
			$hotelInputVal = $scope.find('.hotelInputClass').val();
			if($hotelInputVal.length > 2){
				$scope.find('.tour-display-tui-container').show();
				$scope.find('.hotelInputClass').addClass('hotel-input-boarder');
				let hotellisturl: string = '';
				if (window.location.hostname === 'localhost' && window.location.port == "5000") {
					hotellisturl = '/dummy-data/tourlist.json';
				}
				else {
					hotellisturl = '/bin/services/new/tourpickup?hotelName='+$hotelInputVal;
				}

					$.ajax({
						type: 'GET',
						url: hotellisturl,
						success: function(json:any) {
							if (window.location.hostname !== 'localhost') {
								json = JSON.parse(json);
							}
							_self.tourList($scope, json);
						},
						error: function(error:any) {
							console.log("Error while getting member info", error);
						}
					});		
	
			}
		});

	}
	tourList($scope:any , response:any): any{
		let $hotelList:any = '';
		if(response.tour.length){
			$hotelList += "<div class='hotel-tui-inner'>";
			Object.keys(response).forEach(function(k){
				var itemCity = response[k];		
					if(itemCity.length){
						$hotelList += "<div class=' hotel-title'></div>";
						Object.keys(itemCity).forEach(function(n){
							$hotelList += "<div class='hotel-list' id='"+itemCity[n].to+"' >"+itemCity[n]['pickUpPoint']+"</div>";
						});
						// id='"+itemCity[n].pickUpPoint+"'  data-value='"+itemCity[n].pickUpPoint+"
				}
			});
			$hotelList += "</div>";
			$scope.find('.tour-display-tui-container').html($hotelList).text();
			$scope.find('.hotel-list').on('click', (evt:any) => {
				// var evtVal = $('#'+evt.currentTarget.id).html();
				var evtVal = $('#'+evt.currentTarget.id).text();
				$scope.find('.hotelInputClass').focus();
				var evtValTextArray = evtVal.split('\u003cem\u003e');
				$scope.find('.hotelInputClass').val(evtValTextArray[0]);
				$scope.find('#tourInputVal').val(evt.currentTarget.id);
			//	$scope.find('#hotelInputtoVal').val($('#'+evt.currentTarget.id).data('value').split('|')[0]);
				$scope.find('.tour-display-tui-container').hide();
				$scope.find('.hotelInputClass').removeClass('hotel-input-boarder');

				let $deptDateContainer = $('#tour').find('.dep-date');
				let $rtnDateContainer = $('#tour').find('.rtn-date');
				let $trvInfoContainer = $('#tour').find('.trv-info');
		
				$deptDateContainer.show();
				$rtnDateContainer.show();
				$trvInfoContainer.show();
				if ( $scope.find('.hotelInputClass').val()!=='') {
					$('#tour .departureDate').focus();
					$scope.find('.departureDateMobile').focus();
				}				
			});
		}else{
			$hotelList = "<div class='hotel-not'>No result found! </div>";
			$scope.find('.tour-display-tui-container').html($hotelList);
		}
	}

	populateTuiHotelList($scope: any): void {
		let _self = this;
		let $hotelInputVal: any;
	
		$(document).mouseup(function (event: any) {
			if ($(event.target).closest('.hotel-display-tui-container').length
				=== 0) {
				$scope.find('.hotel-display-tui-container').hide();
				$scope.find('.hotelInputClass').removeClass('hotel-input-boarder');
				$scope.find('#hotelInputWrap__flighthotel .dropdown-icon').removeClass('dropdown-active');
				if ($scope.find('#hotelInputVal').val() === '') {
					$scope.find('.hotelInputClass').val('');
					$scope.find('.hotelInputClass').removeClass('input-focused');
					$('.booking-form--title', $scope.find('.hotelInputClass').parent()).removeClass('input-filled');
				}
			}
		});
		$scope.find('.hotelInputClass').on('keydown', function (e: any) {
			$hotelInputVal = $scope.find('.hotelInputClass').val();
			if ($hotelInputVal.length > 2) {
				let journeytype = $("#transfer-options input[type='radio']:checked").val();
				if (journeytype == 'ToAirport') {
					$scope.find('.from-display-tui-container').show();
					$scope.find('.hotelInputClass').addClass('hotel-input-boarder');
					let hotellisturl: string = '';
					if (window.location.hostname === 'localhost' && window.location.port == "5000") {
						hotellisturl = '/dummy-data/transfer-pickup.json';
					}
					else {
						hotellisturl = '/bin/services/new/transferpickup?hotelName=' + $hotelInputVal;
					}

					$.ajax({
						type: 'GET',
						url: hotellisturl,
						success: function (json: any) {
							if (window.location.hostname !== 'localhost') {
								json = JSON.parse(json);
							}
							_self.transferpickup($scope, json);
						},
						error: function (error: any) {
							console.log("Error while getting member info", error);
						}
					});
				}
				else {
					$scope.find('.hotel-display-tui-container').show();
					$scope.find('#hotelInputWrap__flighthotel .dropdown-icon').addClass('dropdown-active');
					$scope.find('.hotelInputClass').addClass('hotel-input-boarder');
					if($scope[0]==$('#flightHotel2')[0]){
						$.when(window['mHolidaysPdpHotelsList']).done((listData: any) => {
							listData = _self.filterHotelList(listData, $hotelInputVal, 'flightHotel2')
							_self.hotelList($scope, listData);
							
						});
					}
					else{
						$.when(window['mHolidaysHotelsList']).done((listData: any) => {
							listData = _self.filterHotelList(listData, $hotelInputVal, 'flightHotel')
							_self.hotelList($scope, listData);	
						});
					}
									
				}
			}
		});
		$scope.find('#hotelInputWrap__flighthotel #hotelInput__flighthotel').on('click', function (e: any) {
			$scope.find('.hotel-display-tui-container').show();
			$scope.find('#hotelInputWrap__flighthotel .dropdown-icon').addClass('dropdown-active');
			$scope.find('.hotelInputClass').addClass('hotel-input-boarder');
			$.when(window['mHolidaysPdpHotelsList']).done((listData: any) => {
				listData = _self.filterHotelList(listData, 'flighthotelclick', 'flightHotel2')
				_self.hotelList($scope, listData);	
			});
		});

	}
	hotelList($scope:any , response:any): any{
		let $hotelList: any = '';
		if (response.length) {
			$hotelList += "<div class='hotel-tui-inner'>";

			$hotelList += "<div class=' hotel-title'><span>HOTEL</span></div>";
			Object.keys(response).forEach(function (n) {
				if (($scope.selector == "#transferpickup" || $scope.selector == "#transferdrop") && response[n].cityID == "0") {

				} else {
					$hotelList += "<div class='hotel-list' data-hotel" + response[n].cityID + "= 'HotelID' id=hotel-opt" + n + " data-cityId='" + response[n].cityID + "'  data-value='" + response[n].to + "|" + response[n].latitude + "," + response[n].longitude + "'>" + response[n]['hotelName'] + "</div>";
				}
			});


			$hotelList += "</div>";
			$scope.find('.hotel-display-tui-container').html($hotelList).text();
			$scope.find('.hotel-list').on('click', (evt: any) => {
				// var evtVal = $('#' + evt.currentTarget.id).html();
				var evtVal = $('#' + evt.currentTarget.id).text();
				$scope.find('.hotelInputClass').focus();
				var evtValTextArray = evtVal.split('\u003cem\u003e');
				let getcityID: any = $('#' + evt.currentTarget.id).data('cityid');
				$scope.find('.hotelInputClass').val(evtValTextArray[0]);
				$scope.find('#hotelInputVal').val(getcityID);
				$scope.find('#hotelInputtoVal').val($('#' + evt.currentTarget.id).data('value').split('|')[0]);
				if ($scope.selector == "#transferdrop") {
					$scope.find('#geo-coords').val($('#' + evt.currentTarget.id).data('value').split('|')[1]);
				}
				if ($scope.selector == "#transferpickup") {
					$scope.find('#geo-coords').val($('#' + evt.currentTarget.id).data('value').split('|')[1]);
				}
				$scope.find('.hotel-display-tui-container').hide();
				$scope.find('#hotelInputWrap__flighthotel .dropdown-icon').removeClass('dropdown-active');
				$scope.find('.hotelInputClass').removeClass('hotel-input-boarder');

				let $deptDateContainer = $scope.find('.dep-date');
				let $rtnDateContainer = $scope.find('.rtn-date');
				let $trvInfoContainer = $scope.find('.trv-info');

				$deptDateContainer.show();
				$rtnDateContainer.show();
				$trvInfoContainer.show();
				if ($scope.find('.hotelInputClass').val() !== '') {
					$scope.find('.departureDate').focus();
					$('.departuretransferDate').focus();
					$scope.find('.departureDateMobile').focus();
				}
			});
		} else {
			$hotelList = "<div class='hotel-not'>No result found! </div>";
			$scope.find('.hotel-display-tui-container').html($hotelList);
		}
	}

	filterHotelList(listData: any, inputVal: any, activeTab: any): any {
		let returnData: any;
		inputVal = inputVal.toLowerCase();
		if (inputVal === 'flighthotelclick') {
			returnData = $.grep(listData.hotel, function (resultItem: any, resultCount: any) {
				return (resultItem.destination.toUpperCase().trim() == $('.fh-to--location__flighthotel').val().split('-')[1].toUpperCase().trim());
			});
			returnData = $.grep(returnData, function (listItem: any, listCount: any) {
				return (listCount < 2500);
			});
		}
		else {
			if (activeTab === 'flightHotel2') {
				returnData = $.grep(listData.hotel, function (listItem: any, listCount: any) {
					return (listItem.hotelName.toLowerCase().indexOf(inputVal) > -1 && listItem.destination.toUpperCase().trim() == $('.fh-to--location__flighthotel').val().split('-')[1].toUpperCase().trim());
				});
				returnData = $.grep(returnData, function (resultItem: any, resultCount: any) {
					return (resultCount < 2500);
				});
			}
			else {
				returnData = $.grep(listData.hotel, function (listItem: any, listCount: any) {
					return (listItem.hotelName.toLowerCase().indexOf(inputVal) > -1);
				});
				returnData = $.grep(returnData, function (resultItem: any, resultCount: any) {
					return (resultCount < 2500);
				});
			}

		}
		return returnData;
	}

	transferPickupList($scope:any): void {
		let _self = this;
		let $hotelInputVal:any;
		$scope.find('.from-display-tui-container').on('mouseleave', function () {
			 $(this).hide();
			 $scope.find('.hotelInputClass').removeClass('hotel-input-boarder');
		});
		$(document).mouseup(function (event: any) {
			if ($(event.target).closest('.from-display-tui-container').length
				=== 0) {
				$scope.find('.from-display-tui-container').hide();
				$scope.find('.hotelInputClass').removeClass('hotel-input-boarder');
				if($scope.find('#hotelInputVal').val() === '') {
					$scope.find('.hotelInputClass').val('');
					$scope.find('.hotelInputClass').removeClass('input-focused');
					$('.booking-form--title',$scope.find('.hotelInputClass').parent()).removeClass('input-filled');
				}				
			}
		}); 
		$scope.find('.hotelInputClass').on('keydown', function (e:any) {
			$hotelInputVal = $scope.find('.hotelInputClass').val();
			if($hotelInputVal.length > 2){
				let journeytype  = $("#transfer-options input[type='radio']:checked").val();
				if(journeytype != 'ToAirport'){
					$scope.find('.from-display-tui-container').show();
					$scope.find('.hotelInputClass').addClass('hotel-input-boarder');					
				let hotellisturl: string = '';
				if (window.location.hostname === 'localhost' && window.location.port == "5000") {
					hotellisturl = '/dummy-data/transfer-pickup.json';
				}
				else {
					hotellisturl = '/bin/services/new/transferpickup?hotelName='+$hotelInputVal;
				}

					$.ajax({
						type: 'GET',
						url: hotellisturl,
						success: function(json:any) {
							if (window.location.hostname !== 'localhost') {
								json = JSON.parse(json);
							}
							_self.transferpickup($scope, json);
						},
						error: function(error:any) {
							console.log("Error while getting member info", error);
						}
					});		
				}				
				else {
					$scope.find('.hotel-display-tui-container').show();
					$scope.find('.hotelInputClass').addClass('hotel-input-boarder');
					$.when(window['mHolidaysHotelsList']).done((listData: any) => {
						listData = _self.filterHotelList(listData, $hotelInputVal, 'flightHotel')
						_self.hotelList($scope, listData);	
					});
									
				}			
			}
		});

	}
	transferpickup($scope:any , response:any): any{
		let $hotelList:any = '';
		if(response.transfer.length){
			$hotelList += "<div class='hotel-tui-inner'>";
			Object.keys(response).forEach(function(k){
				var itemCity = response[k];		
					if(itemCity.length){
						$hotelList += "<div class=' hotel-title'><span>FROM</span></div>";
						Object.keys(itemCity).forEach(function(n){
							$hotelList += "<div class='hotel-list' id='"+n+"' >"+itemCity[n]['pickUpPoint']+"</div>";
						});
						// id='"+itemCity[n].pickUpPoint+"'  data-value='"+itemCity[n].pickUpPoint+"
				}
			});
			$hotelList += "</div>";
			$scope.find('.from-display-tui-container').html($hotelList).text();
			$scope.find('.hotel-list').on('click', (evt:any) => {
				// var evtVal = $('#'+evt.currentTarget.id).html();
				var evtVal = $('#'+evt.currentTarget.id).text();
				$scope.find('.hotelInputClass').focus();
				var evtValTextArray = evtVal.split('\u003cem\u003e');
				$scope.find('.hotelInputClass').val(evtValTextArray[0]);
				$scope.find('#hotelInputVal').val(evt.currentTarget.id);
				$scope.find('.from-display-tui-container').hide();
				$scope.find('.hotelInputClass').removeClass('hotel-input-boarder');

				let $deptDateContainer = $('#transfer').find('.dep-date');
				let $rtnDateContainer = $('#transfer').find('.rtn-date');
				let $trvInfoContainer = $('#transfer').find('.trv-info');
		
				$deptDateContainer.show();
				$rtnDateContainer.show();
				$trvInfoContainer.show();
				if ( $scope.find('.hotelInputClass').val()!=='') {
					$scope.find('.departureDate').focus();
					$scope.find('.departureDateMobile').focus();
					$('#transferdrop .hotelInputClass').focus();
				}				
			});
		}else{
			$hotelList = "<div class='hotel-not'>No result found! </div>";
			$scope.find('.from-display-tui-container').html($hotelList);
		}
	}

  /**
   * parse source url params into object
   * @param  {string} url [source url with params]
   * @return {any}        [url params object]
   */

	getUrlVars(url:string):any {
	 	let vars:Array<any> = [],
	 			hash:any;
	 	let hashes:any = url.slice(url.indexOf('?') + 1).split('&');

	 	for (var i = 0; i < hashes.length; i++) {
	 		hash = hashes[i].split('=');
	 		vars.push(hash[0]);
	 		vars[hash[0]] = hash[1];
	 	}

	 	return vars;
	}
		/**
		 * [getCookieByMatch description]
		 * @param {string} regex [description]
		 */
	getCookieByMatch(regex:RegExp) {
		let cs:any = document.cookie.split(/;\s*/),
				ret:Array<any> = [];
		for (var i:number = 0; i < cs.length; i++) {
			if (cs[i].match(regex)) {
				ret.push(cs[i]);
			}
		}
		return ret ;
	}
	/* Read cookie value by name */
	readValueFromCookie(name: string): any {
			var json = "";
			var ca = document.cookie.split(';');

			name = name + "=";

			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return decodeURIComponent(c.substring(name.length, c.length).replace(/\+/g, ' '));
				};
			}
		return json;
	}
	getSmartAlertsAirPorts() {
		// every static rendering will use promise. no need to worry about async issue
		let defer = $.Deferred();
		let _self = this;
		let smartAlertsListUrl = $('[data-get-smart-alerts-airport-list]').attr('data-get-smart-alerts-airport-list');	
		if (smartAlertsListUrl) {
			$.get(smartAlertsListUrl)
				.done((data:any) => {
					let dataParse:any = null;

					if (typeof data === 'string') {
						dataParse = JSON.parse(data);
					}	else {
						dataParse = data;
					}

					defer.resolve(dataParse);
				}).fail((error:any) => {
					defer.reject(error);
				});
		}
		return defer.promise();
	}

	parseSmartAlertsOND(response: any, type: string, destinationtype: string): string {
		let listItems: string = "<option value=''> </option>";
		let _self = this;
		if (type === 'smartAlerts') {
			if (response[type] !== undefined) {
				for (let key in response[type]) {
					if (response[type][key] !== undefined) {
						if (key === 'online') {
							listItems += "<optgroup label='With Malaysia Airlines'>";

							for (let key1 in response[type][key]) {
								if (response[type][key][key1] !== undefined) {
									// filter revenue data out of entire OnD list
									let dest: revenueObject = response[type][key][key1];
									listItems += "<option value='" + dest.source.airportCode + "'>" +
										dest.source.airportName + "|" + dest.source.countryName +
										"|" + dest.source.airportCode +
										"</option>";
								}
							}
						}
						else if (key === 'others') {

							listItems += "<optgroup label='With codeshare and partner network'>";

							for (let key1 in response[type][key]) {
								if (response[type][key][key1] !== undefined) {
									// filter revenue data out of entire OnD list
									let dest: revenueObject = response[type][key][key1];
									listItems += "<option value='" + dest.source.airportCode + "'>" +
										dest.source.airportName + "|" + dest.source.countryName +
										"|" + dest.source.airportCode +
										"</option>";
								}
							}
						}
					}
				}
				if (destinationtype === 'From') {
					listItems += "</optgroup>";
				}
			}
		}
		return listItems;
	}

	updatesmartAlertsAirportList(flowType: any, originCode: any, updateType: any) {
		let type = 'smartAlerts';
		let selectOptions: Array<any> = [];
		$.when(window['smartAlertsOnDList']).done((listData: any) => {
			let airportList = listData;
			if (originCode === '') { // when changing payment type (cash/miles)				
				if (airportList[type] !== undefined) {
					for (let key in airportList[type]) {
						if (airportList[type][key] !== undefined) {
							if (key === 'online') {
								for (let key1 in airportList[type][key]) {
									if (airportList[type][key][key1] !== undefined) {
										// filter revenue/redemption data out of entire OnD list
										let dest: revenueObject = airportList[type][key][key1];
										selectOptions.push({
											text: dest.source.airportName + "|" + dest.source.countryName + "|" + dest.source.airportCode,
											value: dest.source.airportCode,
											type: 'online'
										});
									}

								}
							}
							else if (key === 'others') {
								for (let key1 in airportList[type][key]) {
									if (airportList[type][key][key1] !== undefined) {
										// filter revenue/redemption data out of entire OnD list
										let dest: revenueObject = airportList[type][key][key1];
										selectOptions.push({
											text: dest.source.airportName + "|" + dest.source.countryName + "|" + dest.source.airportCode,
											value: dest.source.airportCode,
											type: 'other'
										});
									}

								}
							}
						}
					}
				}
			}
			else { // when changing src destination
				// console.log('with origin code', originCode);
				if (airportList[type] !== undefined) {
					for (let key in airportList[type]) {
						if (airportList[type][key] !== undefined) {
							for (let key1 in airportList[type][key]) {
								if (airportList[type][key][key1] !== undefined) {
									if (airportList[type][key][key1].source.airportCode === originCode) {
										let originname: string = airportList[type][key][key1].source.airportName;
										let dest: Array<any> = airportList[type][key][key1]['destinations'];
										if (dest !== undefined) {
											for (let key in dest) {
												if (key === 'online') {
													if (dest[key].length) {
														for (let key1 in dest[key][0]) {
															// filter revenue/redemption data out of entire OnD list
															let dest2: destObject = dest[key][0][key1];
															selectOptions.push({
																text: dest2.airportName + "|" + dest2.countryName + "|" + dest2.airportCode,
																value: dest2.airportCode,
																type: 'online'
															});

														}
													}

												}
												else if (key === 'others') {
													if (dest[key].length) {
														for (let key1 in dest[key][0]) {
															// filter revenue/redemption data out of entire OnD list
															let dest2: destObject = dest[key][0][key1];
															selectOptions.push({
																text: dest2.airportName + "|" + dest2.countryName + "|" + dest2.airportCode,
																value: dest2.airportCode,
																type: 'other'
															});

														}
													}
												}
											}
										}
									}
								}
							}

						}
					}
				}
			}

			let updateLocationType: any;
			// console.log('update type', typeof updateType);
			// console.log(updateType);
			if (typeof updateType === 'string') {
				// for original implementation (where used in bookingform ibe only)
				updateLocationType = $('.ibe-form--container').find(updateType);
			} else {
				// for all other OnD lists (new)
				updateLocationType = updateType;
			}
			let selectize = updateLocationType[0].selectize;

			selectize.clearOptions();
			selectize.renderCache = {};

			//selectize.load(this.populateFromLocRecentSearch(listItems, flowType, listData));
			selectize.load(function (callback: any) {
				for (var i: number = 0; i < selectOptions.length; i++) {
					if (selectOptions[i].type === 'online') {
						selectize.addOptionGroup("online", {
							label: "With Malaysia Airlines"
						});
						selectize.addOption({
							text: selectOptions[i].text,
							value: selectOptions[i].value,
							optgroup: "online"
						});
					}
					else if (selectOptions[i].type === 'other') {
						selectize.addOptionGroup("other", {
							label: "With codeshare and partner network"
						});
						selectize.addOption({
							text: selectOptions[i].text,
							value: selectOptions[i].value,
							optgroup: "other"
						});
					}
				}
				callback();
			});
		});

	}
	hotelListNew(): any {
		// every static rendering will use promise. no need to worry about async issue
		let defer = $.Deferred();
		let _self = this;
		let hotelListUrl;
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			hotelListUrl = '/dummy-data/hotelListnew.json';
		}
		else {
			hotelListUrl = '/content/mas-admin/mholidayService/getOndDetails/en.json';
		}
		let listItems:string;
		let campaignID = $('[data-campaign-hotel-list-campaignID]').data('campaignHotelListCampaignid');
		
		if(campaignID==='HOOND' || campaignID==undefined){
		if (hotelListUrl) {
				$.get(hotelListUrl)
				.done((data:any) => {
					let dataParse:any = null;

					if (typeof data === 'string') {
						dataParse = JSON.parse(data);
					}	else {
						dataParse = data;
					}
					defer.resolve(dataParse);
				}).fail((error:any) => {
					defer.reject(error);
				});
			}
		}
		else{
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				$.get(hotelListUrl)
				.done((data:any) => {
					let dataParse:any = null;

					if (typeof data === 'string') {
						dataParse = JSON.parse(data);
					}	else {
						dataParse = data;
					}
					defer.resolve(dataParse);
				}).fail((error:any) => {
					defer.reject(error);
				});
			}else{
			let data = {
				mholidayHotelCampaignId: campaignID
			};
			$.ajax({
				type: 'POST',
				url: '/bin/services/new/campaign/mholidayhotellist',
				data: data,
				success: function(dataParse:any){
					
					defer.resolve(dataParse);			
				}, error: function(error: any) {
					defer.reject(error);
				}
			});
		}
	}
		return defer.promise();
	}

	pdpMholidayList():any{
		let defer = $.Deferred();
		let campaignID=$('[data-ond-flightHotel-campaignID]').data('ondFlighthotelCampaignid');
		let data =  {
			mholidayONDCampaignId: campaignID
		};
		
        if(window.location.hostname == "localhost" && window.location.port == "5000"){
			let airportListUrl = '/dummy-data/getMholidaysOND.json';
			
			if(campaignID==='FHOOND' || campaignID===undefined){
				if(airportListUrl) {
					$.get(airportListUrl)
						.done((data:any) => {
							let dataParse:any = null;
		
							if (typeof data === 'string') {
								dataParse = JSON.parse(data);
							}	else {
								dataParse = data;
							}
							//dataParse.type = "mholiday";
							defer.resolve(dataParse);
						}).fail((error:any) => {
							defer.reject(error);
						});
				}
			}else{
				$.ajax({
					type: 'GET',
					url: airportListUrl,
					data: data,
					success: function(dataParse:any){
						defer.resolve(dataParse);			
					}, error: function(error: any) {
						defer.reject(error);
					}
				});
			}
        }else{
			if(campaignID==='FHOOND' || campaignID===undefined){
				$.ajax({
					type: 'GET',
					url: '/bin/services/new/mholidayond',
					success: function(dataParse:any){
					   // dataParse.type = "mholiday";
						defer.resolve(dataParse);			
					}, error: function(error: any) {
						defer.reject(error);
					}
				});
			}
			else{
				$.ajax({
					type: 'POST',
					url: '/bin/services/new/campaign/mholidayOND',
					data: data,
					success: function(dataParse:any){
						defer.resolve(dataParse);			
					}, error: function(error: any) {
						defer.reject(error);
					}
				});
			}
        }
		return defer.promise();
	}

	updateMholidaysPdpOnDListOnFlowChange(flowType:any, originCode:any, updateType:any):void {

		let _self = this;

		_self.pdpMholidayList().then((listData: any) => {

			let type:string = flowType;
			let airportList = listData;
			let selectOptions:Array<any> = [];

			if (originCode === '') { 
				if (airportList[type].length) {
					for (let key in airportList[type][0]) {
						let dest:mholidayObject = airportList[type][0][key];
						
						selectOptions.push({
							text: dest.source.airportName + ", " + dest.source.countryName + " (" + dest.source.airportCode + ")",
							value: dest.source.cityCode+"-"+dest.source.airportCode
						});
					}
				}
			} else { // when changing src destination
				// console.log('with origin code', originCode);
				if (airportList[type].length) {
					let dest:Array<any> = airportList[type][0][originCode]['destinations'];
					if (dest.length) {
						for (let key in dest[0]) {
							let dest2:mholidayDestObject = dest[0][key];
							selectOptions.push({
								text: dest2.airportName + ", " + dest2.countryName + " (" + dest2.airportCode + ")",
								value: dest2.cityCode+"-"+dest2.airportCode
							});
						}
					}
				}
			}

			let updateLocationType:any;
			// console.log('update type', typeof updateType);
			// console.log(updateType);
			if (typeof updateType === 'string') {
				// for original implementation (where used in bookingform ibe only)
				updateLocationType = $('.ibe-form--container').find(updateType);
			} else {
				// for all other OnD lists (new)
				updateLocationType = updateType;
			}
			let selectize = updateLocationType[0].selectize;

			selectize.clearOptions();
			selectize.renderCache = {};
			selectize.load(function(callback:any) {
				callback(selectOptions);
			});
		});
	}

	pdpHotelList():any{
		// every static rendering will use promise. no need to worry about async issue
		let defer = $.Deferred();
		let _self = this;
		let hotelListUrl;
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			hotelListUrl = '/dummy-data/hotelListnew.json';
		}
		else {
			hotelListUrl = '/content/mas-admin/mholidayService/getOndDetails/en.json';
		}
		let listItems:string;
		let campaignID = $('[data-ond-hotel-campaignID]').data('ondHotelCampaignid');
		
		if(campaignID==='HOOND' || campaignID==undefined){
		if (hotelListUrl) {
				$.get(hotelListUrl)
				.done((data:any) => {
					let dataParse:any = null;

					if (typeof data === 'string') {
						dataParse = JSON.parse(data);
					}	else {
						dataParse = data;
					}
					defer.resolve(dataParse);
				}).fail((error:any) => {
					defer.reject(error);
				});
			}
		}
		else{
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				$.get(hotelListUrl)
				.done((data:any) => {
					let dataParse:any = null;

					if (typeof data === 'string') {
						dataParse = JSON.parse(data);
					}	else {
						dataParse = data;
					}
					defer.resolve(dataParse);
				}).fail((error:any) => {
					defer.reject(error);
				});
			}else{
			let data = {
				mholidayHotelCampaignId: campaignID
			};
			$.ajax({
				type: 'POST',
				url: '/bin/services/new/campaign/mholidayhotellist',
				data: data,
				success: function(dataParse:any){
					
					defer.resolve(dataParse);			
				}, error: function(error: any) {
					defer.reject(error);
				}
			});
		}
	}
		return defer.promise();
	}
}

